export default {
  translation: {
    apiError: {
      INVALID_INPUT: 'Ungültige Eingabe. Bitte überprüfen Sie Ihre Daten.',
      NOT_FOUND: 'Die angeforderte Ressource wurde nicht gefunden.',
      INTERNAL_ERROR: 'Interner Serverfehler. Bitte versuche es später erneut.',
      UNAUTHORIZED:
        'Sie sind nicht autorisiert. Bitte melden Sie sich an, um fortzufahren.',
      FORBIDDEN:
        'Zugriff verweigert. Sie haben keine Berechtigung, diese Aktion durchzuführen.',
      CONTENT_POLICY_VIOLATION:
        'Leider kann ich diese Frage nicht beantworten.\n\nKontaktieren Sie in Notfällen bitte medizinisches oder psychologisches Fachpersonal oder die örtlichen Notdienste.',
      CONNECTION_ERROR:
        'Verbindungsfehler. Bitte überprüfen Sie Ihre Netzwerkverbindung.',
    },
    common: {
      delete: 'Löschen',
      deleteModalTitle: 'Möchten Sie diesen Artikel wirklich löschen?',
      evaluation: 'Auswertung',
      ok: 'Ja',
      cancel: 'Abbrechen',
      total: 'Gesamt',
      rename: 'Umbenennen',
      name: 'Name',
      save: 'Speichern',
      namePlaceholder: 'Bitte geben Sie den Namen ein',
      next: 'Nächste',
      create: 'Erstellen',
      edit: 'Bearbeiten',
      upload: 'Hochladen',
      english: 'Englisch',
      german: 'Deutsch',
      french: 'Französisch',
      spanish: 'Spanisch',
      italian: 'Italienisch',
      dutch: 'Niederländisch',
      portuguese: 'Portugiesisch',
      russian: 'Russisch',
      polish: 'Polnisch',
      romanian: 'Rumänisch',
      ukrainian: 'Ukrainisch',
      turkish: 'Türkisch',
      arabic: 'Arabisch',
      bosnian: 'Bosnisch',
      chinese: 'Vereinfachtes Chinesisch',
      traditionalChinese: 'Traditionelles Chinesisch',
      language: 'Sprache',
      languageMessage: 'Bitte geben Sie Ihre Sprache ein!',
      languagePlaceholder: 'Wählen Sie Ihre Sprache aus',
      copy: 'Kopie',
      copied: 'Kopiert',
      comingSoon: 'Kommt bald',
      download: 'Herunterladen',
      close: 'Schließen',
      preview: 'Vorschau',
      move: 'Bewegen',
      warn: 'Warnung',
      action: 'Aktion',
      s: 'S',
      pleaseSelect: 'Bitte auswählen',
      pleaseInput: 'Bitte eingeben',
      submit: 'Einreichen',
      embedIntoSite: 'Teilen',
      previousPage: 'Vorherige',
      nextPage: 'Nächste',
      import: 'Importieren',
      detail: 'Details',
      editSuccess: 'Erfolgreich bearbeitet',
      createSuccess: 'Erfolgreich erstellt',
      operationFailed: 'Vorgang fehlgeschlagen',
      properties: 'Eigenschaften',
      propertyName: 'Eigenschaftsname',
      nameRequired: 'Name ist erforderlich',
      addProperty: 'Eigenschaft hinzufügen',
      addItem: 'Eintrag hinzufügen',
      itemCount: 'Einträge',
      createTime: 'Erstellt am',
      search: 'Suchen',
      description: 'Beschreibung',
      required: 'Pflichtfeld',
      saveSuccess: 'Erfolgreich gespeichert',
      saveFailed: 'Speichern fehlgeschlagen',
      more: 'Mehr',
      less: 'Weniger',
      duplicate: 'Duplizieren',
    },
    login: {
      login: 'Anmelden',
      loginDescription: 'Wir freuen uns, Sie wiederzusehen!',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      passwordLabel: 'Passwort',
      passwordPlaceholder: 'Bitte geben Sie das Passwort ein',
      rememberMe: 'Erinnere dich an mich',
      incorrectCredentials: 'E-Mail-Adresse oder Passwort ist falsch.',
      title: 'Buddy Management.',
      description: 'Erstellen Sie Wissensdatenbanken',
      review: 'aus über 500 Bewertungen',
    },
    passwordStrength: {
      tooWeak: 'Zu schwach',
      weak: 'Schwach',
      fair: 'Mittel',
      strong: 'Stark',
    },
    header: {
      knowledgeBase: 'Wissen',
      chat: 'Buddys',
      register: 'Registrieren',
      signin: 'Anmelden',
      home: 'Home',
      setting: 'Benutzereinstellungen',
      logout: 'Abmelden',
      fileManager: 'Dateiverwaltung',
      flow: 'Workflows',
      search: 'Schnelltest',
    },
    knowledgeList: {
      welcome: 'Willkommen zurück',
      description: 'Welche Wissensdatenbanken werden Sie heute nutzen?',
      createKnowledgeBase: 'Wissensdatenbank erstellen',
      name: 'Name',
      namePlaceholder: 'Bitte Namen eingeben!',
      doc: 'Dokumente',
      searchKnowledgePlaceholder: 'Suchen',
      noMoreData: 'Alle Wissensdatenbanken wurden geladen.',
    },
    knowledgeDetails: {
      dataset: 'Datensatz',
      testing: 'Testen der Suche',
      crawler: 'Crawler',
      files: 'Dateien',
      configuration: 'Konfiguration',
      name: 'Name',
      namePlaceholder: 'Bitte Namen eingeben!',
      doc: 'Dokumente',
      addFile: 'Inhalte hinzufügen',
      searchFiles: 'Durchsuchen Sie Ihre Dateien',
      localFiles: 'Lokale Dateien',
      emptyFiles: 'Leere Datei erstellen',
      webCrawl: 'Web-Crawl',
      chunkNumber: 'Chunk-Nummer',
      uploadDate: 'Upload-Datum',
      publicationYear: 'Erscheinungsjahr',
      publicationYearTip:
        'Das Jahr, in dem der Inhalt veröffentlicht wurde — nicht das Datum des Uploads. Leer lassen, wenn unbekannt; der Assistent erfährt das Jahr nur bei Dokumenten, die eines haben.',
      publicationYearPlaceholder: 'z. B. 2024',
      publicationYearInvalid:
        'Bitte ein Jahr zwischen {{min}} und {{max}} angeben.',
      chunkMethod: 'Chunk-Methode',
      enabled: 'Aktivieren',
      showInReferences: 'Anzeigen',
      disabled: 'Deaktivieren',
      action: 'Aktion',
      parsingStatus: 'Parsing-Status',
      processBeginAt: 'Gestartet am',
      commonTags: 'Stichwörter',
      processDuration: 'Dauer',
      progressMsg: 'Fortschritt',
      crawlReport: 'Crawler-Report',
      crawlReportStartUrl: 'Start-URL',
      crawlReportSummary: 'Zusammenfassung',
      crawlReportSummaryText:
        '{{total}} Seiten insgesamt, {{successful}} erfolgreich, {{errors}} fehlgeschlagen.',
      crawlReportSuccessfulPages: 'Erfolgreiche Seiten',
      crawlReportUrl: 'URL',
      crawlReportStatusCode: 'Statuscode',
      crawlReportErrorMessage: 'Fehlermeldung',
      crawlReportReason: 'Wahrscheinliche Ursache',
      crawlReportTitle: 'Titel',
      crawlReportNotAvailable: 'Noch kein Crawler-Report verfügbar.',
      crawlReportNoErrors: 'Keine Fehler – alle Seiten erfolgreich gecrawlt.',
      crawlReportDownload: 'Report herunterladen',
      crawlReportConfig: 'Crawl-Konfiguration',
      crawlReportOutcome: 'Ergebnis',
      crawlReportOutcomeNew: 'Neu',
      crawlReportOutcomeUpdated: 'Aktualisiert',
      crawlReportOutcomeUnchanged: 'Unverändert – übersprungen',
      crawlReportDelta: 'Seit letztem Lauf',
      crawlReportDeltaText:
        '{{new}} neu, {{updated}} aktualisiert, {{unchanged}} unverändert (nicht erneut analysiert).',
      crawlReportNotAnalyzed:
        'Die Analyse nach dem Crawl war für diesen Lauf deaktiviert – Seiten wurden gecrawlt und als Dokumente gespeichert, aber nicht geparst oder eingebettet. Bei Bedarf können sie manuell über den Datensatz-Tab ausgeführt werden.',
      crawlReportCancelledTitle: 'Dieser Crawl wurde vorzeitig gestoppt',
      crawlReportCancelledDescription:
        'Er wurde nach der Prüfung von {{total}} Seiten abgebrochen – es könnten weitere Seiten auf der Website vorhanden sein, die noch nicht erreicht wurden.',
      crawlReportRemoved: 'Entfernt seit letztem Lauf',
      crawlReportRemovedText:
        '{{removed}} zuvor von dieser Quelle gecrawlte Seite(n) wurden gelöscht, da sie in diesem Lauf fehlten.',
      crawlReportRemovedPages: 'Entfernte Seiten',
      crawlReportDeletionSkippedCancelled:
        'Fehlende Seiten löschen war aktiviert, aber dieser Lauf wurde abgebrochen – es wurden keine Seiten gelöscht, da ein gestoppter Crawl möglicherweise noch existierende Seiten nicht erreicht hat.',
      crawlReportDeletionSkippedMaxPagesFirstHit:
        'Fehlende Seiten löschen war aktiviert, aber dieser Lauf hat sein Limit für maximale Seiten erstmals erreicht – es wurden keine Seiten gelöscht, da kein früherer, ebenfalls begrenzter Lauf zum Vergleich vorliegt, um zu bestätigen, dass eine fehlende Seite wirklich verschwunden und nicht nur diesmal außerhalb der Reichweite ist.',
      crawlReportDeletionSkippedNoPagesFetched:
        'Fehlende Seiten löschen war aktiviert, aber dieser Lauf hat keine einzige Seite erfolgreich abgerufen – es wurden keine Seiten gelöscht, da ein fehlgeschlagener Crawl (Website nicht erreichbar, abgelaufener Login, blockierte Startseite) eine gelöschte Seite nicht von einer nur nicht erreichbaren unterscheiden kann.',
      crawlReportDeletionSkippedMaxPagesChanged:
        'Fehlende Seiten löschen war aktiviert, aber das Limit für maximale Seiten dieses Laufs unterscheidet sich vom vorherigen begrenzten Lauf – es wurden keine Seiten gelöscht, da der Vergleich zweier unterschiedlicher Limits kein verlässlicher Beleg dafür ist, dass eine Seite wirklich verschwunden ist.',
      crawlReportDeletionSkippedConfigChanged:
        'Fehlende Seiten löschen war aktiviert, aber eine Einstellung, die beeinflusst, welche Seiten dieser Crawl erreichen kann (Start-URL, Erkennungsmodus, maximale Tiefe oder ein URL-/Typ-Filter), hat sich seit dem letzten Lauf geändert – es wurden keine Seiten gelöscht, da eine Seite durch eine engere Konfiguration herausfallen kann, ohne von der Website entfernt worden zu sein.',
      crawlSourceAnalyzeAfterCrawl: 'Nach Crawl analysieren',
      crawlSourceAnalyzeAfterCrawlTooltip:
        'Wenn aktiviert (Standard), werden gecrawlte Seiten direkt nach dem Crawl automatisch geparst und eingebettet. Wenn deaktiviert, werden Seiten weiterhin gecrawlt und als Dokumente gespeichert, aber erst bei manueller Ausführung analysiert.',
      crawlSourceIncludeImagesInChangeDetection:
        'Bilder für Änderungserkennung berücksichtigen',
      crawlSourceIncludeImagesInChangeDetectionTooltip:
        'Wenn aktiviert (Standard), gilt eine Seite beim erneuten Crawl als geändert, sobald sich eine ihrer Bildreferenzen ändert. Wenn deaktiviert, werden Bildreferenzen bei der Änderungserkennung ignoriert — eine Seite mit unverändertem Text wird also nicht erneut eingelesen, nur weil sich eine Bild-URL geändert hat (z. B. durch Cache-Busting). Gilt nur für HTML-Seiten; PDFs werden immer vollständig verglichen.',
      crawlSourceDeleteMissingPages:
        'Seiten löschen, die im letzten Crawl fehlen',
      crawlSourceDeleteMissingPagesTooltip:
        'Wenn aktiviert, wird eine zuvor von dieser Quelle gecrawlte Seite gelöscht (Dokument, Chunks und Datei), sobald sie in einem Lauf nicht mehr gefunden wird — sie gilt dann als von der Website entfernt. Wenn deaktiviert (Standard), bleiben solche Seiten unangetastet. Wird bei einem abgebrochenen Lauf oder einem Lauf, der die maximale Seitenzahl erstmals erreicht, übersprungen, da „fehlend“ in diesen Fällen kein verlässlicher Beleg für eine Löschung ist.',
      crawlSourceDeleteMissingPagesDeepCrawlWarning:
        'Bei der Link-Verfolgung (Deep Crawl) kann eine Seite in einem Lauf fehlen, nur weil aktuell nichts mehr auf sie verlinkt – nicht, weil sie von der Website entfernt wurde. Die Sitemap-Erkennung liefert für diese Einstellung ein verlässlicheres Signal.',
      crawlSourceDescription:
        'Speichern Sie wiederverwendbare Web-Crawl-Konfigurationen und führen Sie sie erneut aus, sobald sich die Quellinhalte ändern. Eine Crawl-Quelle erfasst bei jedem Lauf nur neue oder geänderte Seiten.',
      crawlSourceCreate: 'Neue Crawl-Quelle',
      crawlSourceEdit: 'Crawl-Quelle bearbeiten',
      crawlSourceName: 'Name',
      crawlSourceNamePlaceholder: 'Bitte Namen eingeben!',
      crawlSourceStartUrl: 'Start-URL',
      crawlSourceStatus: 'Status',
      crawlSourceLastRun: 'Letzter Lauf',
      crawlSourceNeverRun: 'Noch nie ausgeführt',
      crawlSourceRunNotFinished: 'Noch nicht abgeschlossen',
      crawlSourceRunNow: 'Jetzt ausführen',
      crawlSourceStop: 'Diesen Durchlauf stoppen',
      crawlSourceAlreadyRunning: 'Es läuft bereits ein Durchlauf',
      crawlSourceRunHistory: 'Verlauf',
      crawlSourceRunHistoryEmpty: 'Noch keine Durchläufe vorhanden.',
      crawlSourceRunDate: 'Datum',
      crawlSourceRunDone: 'Fertig',
      crawlSourceRefresh: 'Aktualisieren',
      crawlSourceBackToHistory: 'Zurück zum Verlauf',
      crawlSourceViewReport: 'Report anzeigen',
      crawlSourceDelete: 'Löschen',
      crawlSourceCannotDeleteRunning:
        'Stoppen Sie den Lauf und warten Sie, bis er beendet ist, bevor Sie löschen',
      crawlSourceDeleteConfirm:
        'Möchten Sie diese Crawl-Quelle wirklich löschen? Bereits erstellte Dokumente sind davon nicht betroffen.',
      crawlRunDelete: 'Löschen',
      crawlRunDeleteConfirm:
        'Möchten Sie diesen Durchlauf wirklich löschen? Sein Verlaufseintrag und Report werden endgültig entfernt. Bereits erstellte Dokumente sind davon nicht betroffen.',
      crawlRunCannotDeleteLatest:
        'Der letzte Durchlauf kann nicht gelöscht werden – er wird in der Status-Spalte angezeigt.',
      crawlSourceEmpty: 'Noch keine Crawl-Quellen vorhanden.',
      crawlSourceCreateSuccess: 'Crawl-Quelle erstellt.',
      crawlSourceUpdateSuccess: 'Crawl-Quelle aktualisiert.',
      crawlSourceDeleteSuccess: 'Crawl-Quelle gelöscht.',
      crawlSourceRunStarted:
        'Crawl gestartet – der Report ist in Kürze verfügbar.',
      crawlSourceCrawling: 'Crawlt',
      crawlSourceStopping: 'Wird gestoppt…',
      crawlSourceStoppingHint:
        'Der aktuelle Batch wird noch beendet, bevor angehalten wird — das kann einen Moment dauern.',
      crawlSourceCrawlFailed: 'Crawl fehlgeschlagen',
      crawlSourceCrawlCancelled: 'Crawl abgebrochen',
      crawlSourcePagesProcessed: '{{done}} von {{total}} Seiten verarbeitet',
      crawlSourcePagesNotAnalyzed:
        '{{total}} Seiten gecrawlt, nicht analysiert',
      crawlSourcePagesFailed: '{{count}} fehlgeschlagen',
      crawlSourcePagesCancelled: '{{count}} abgebrochen',
      crawlSourcePagesNotAnalyzedCount: '{{count}} nicht analysiert',
      crawlSourceSchedule: 'Zeitplan',
      crawlSourceScheduleOff: 'Aus',
      crawlSourceScheduleEdit: 'Zeitplan bearbeiten',
      crawlSourceScheduleTitle: 'Wiederkehrender Zeitplan',
      crawlSourceScheduleEnabled: 'Automatisch ausführen',
      crawlSourceScheduleFrequency: 'Häufigkeit',
      crawlSourceScheduleWeekly: 'Wöchentlich',
      crawlSourceScheduleMonthly: 'Monatlich',
      crawlSourceScheduleDayOfWeek: 'Wochentag',
      crawlSourceScheduleDayOfMonth: 'Tag im Monat',
      crawlSourceScheduleTime: 'Uhrzeit',
      crawlSourceScheduleEndDate: 'Enddatum',
      crawlSourceScheduleEndDateHint:
        'Optional — keine Läufe nach diesem Datum.',
      crawlSourceScheduleDayOfMonthHint:
        'In kürzeren Monaten läuft der Crawl am letzten Tag des Monats.',
      crawlSourceScheduleUpdateSuccess: 'Zeitplan aktualisiert.',
      crawlSourceScheduleSummaryMonthly: 'Tag {{day}}',
      crawlSourceScheduleNextRun: 'Nächster Lauf: {{time}}',
      crawlSourceScheduleEnded: 'Beendet',
      crawlSourceWeekday0: 'Montag',
      crawlSourceWeekday1: 'Dienstag',
      crawlSourceWeekday2: 'Mittwoch',
      crawlSourceWeekday3: 'Donnerstag',
      crawlSourceWeekday4: 'Freitag',
      crawlSourceWeekday5: 'Samstag',
      crawlSourceWeekday6: 'Sonntag',
      testingDescription:
        'Führen Sie einen Suchtest durch, um zu prüfen, ob Buddy CMS den beabsichtigten Inhalt für das LLM wiederherstellen kann.',
      similarityThreshold: 'Schwellenwert',
      similarityThresholdTip:
        'Buddy CMS verwendet beim Abruf entweder eine Kombination aus gewichteter Keyword-Ähnlichkeit und gewichteter Vektor-Ähnlichkeit oder eine Kombination aus gewichteter Keyword-Ähnlichkeit und gewichtetem Reranking-Score. Dieser Parameter legt den Schwellenwert für Ähnlichkeiten zwischen der Benutzerabfrage und Chunks fest. Jeder Block mit einem Ähnlichkeitswert unter diesem Schwellenwert wird aus den Ergebnissen ausgeschlossen.',
      vectorSimilarityWeight: 'Vektorähnlichkeitsgewicht',
      vectorSimilarityWeightTip:
        'Legt das Verhältnis zwischen Keyword-Suche und semantischer Suche fest. Bei einem Wert von 1 wird ausschließlich nach Schlüsselwörtern gesucht, bei 0 ausschließlich semantisch (vektorbasiert). Werte dazwischen kombinieren beide Methoden – die Summe beider Gewichte muss stets 1,0 ergeben.',
      testText: 'Testtext',
      testTextPlaceholder: 'Geben Sie hier Ihre Frage ein!',
      testingLabel: 'Testen',
      similarity: 'Hybride Ähnlichkeit',
      termSimilarity: 'Begriffsähnlichkeit',
      vectorSimilarity: 'Vektorähnlichkeit',
      hits: 'Treffer',
      view: 'Sicht',
      filesSelected: 'Dateien ausgewählt',
      upload: 'Hochladen',
      run: 'Analysieren',
      runningStatus0: 'Nicht verarbeitet',
      runningStatus1: 'Analysiere',
      runningStatus2: 'Abgebrochen',
      runningStatus3: 'Erfolgreich',
      runningStatus4: 'Fehler',
      pageRanges: 'Seitenbereiche',
      pageRangesTip:
        'Bereich der zu analysierenden Seiten; Seiten außerhalb dieses Bereichs werden nicht verarbeitet.',
      fromPlaceholder: 'aus',
      fromMessage: 'Fehlende Startseitennummer',
      toPlaceholder: 'Zu',
      toMessage: 'Fehlende Endseitenzahl (ausgeschlossen)',
      layoutRecognize: 'Layouterkennung',
      layoutRecognizeTip:
        'Verwenden Sie visuelle Modelle für die Layoutanalyse, um die Struktur des Dokuments besser zu verstehen und Dokumenttitel, Textblöcke, Bilder und Tabellen effektiv zu finden. Wenn deaktiviert, wird nur der reine Text im PDF abgerufen.',
      taskPageSize: 'Maximale Anzahl von Seiten pro Verarbeitung',
      taskPageSizeMessage:
        'Bitte geben Sie die maximale Anzahl von Seiten Ihrer Verarbeitung ein!',
      taskPageSizeTip: `Bei der Layouterkennung wird eine PDF-Datei in Blöcke aufgeteilt und parallel verarbeitet, um die Verarbeitungsgeschwindigkeit zu erhöhen. Dieser Parameter legt die Größe jedes Blocks fest. Eine größere Blockgröße verringert die Wahrscheinlichkeit, dass fortlaufender Text zwischen Seiten aufgeteilt wird.`,
      addPage: 'Seite hinzufügen',
      greaterThan: 'Der aktuelle Wert muss größer sein als to!',
      greaterThanPrevious:
        'Der aktuelle Wert muss größer sein als der vorherige!',
      selectFiles: 'Wählen Sie Dateien aus',
      changeSpecificCategory: 'Bestimmte Kategorie ändern',
      uploadTitle:
        'Klicken oder ziehen Sie die Datei zum Hochladen in diesen Bereich',
      uploadDescription:
        'Unterstützung für einen einzelnen oder Massen-Upload. Das Hochladen von Unternehmensdaten oder anderen verbotenen Dateien ist strengstens untersagt.',
      chunk: 'Chunk',
      bulk: 'Liste',
      cancel: 'Abbrechen',
      rerankModel: 'Reranker',
      rerankPlaceholder: 'Bitte auswählen',
      rerankTip: `Wenn es leer bleibt, verwendet Buddy CMS eine Kombination aus gewichteter Schlüsselwortähnlichkeit und gewichteter Vektorkosinusähnlichkeit. Wenn ein Reranking-Modell ausgewählt wird, ersetzt ein gewichteter Reranking-Score die gewichtete Vektor-Kosinus-Ähnlichkeit.`,
      topK: 'Top-K',
      topKTip: `K-Blöcke werden in Rerank-Modelle eingespeist.`,
      delimiter: `Trennzeichen`,
      delimiterTip:
        'Ein Begrenzer oder Trennzeichen kann aus einem oder mehreren Sonderzeichen bestehen. Wenn es sich um mehrere Zeichen handelt, stellen Sie sicher, dass sie in Backticks( ``) eingeschlossen sind. Wenn Sie Ihre Trennzeichen beispielsweise wie folgt konfigurieren: \n`##`;, dann werden Ihre Texte durch Zeilenumbrüche, doppelte Rautenzeichen (##) oder Semikolons getrennt.',
      html4excel: 'Excel zu HTML',
      html4excelTip: `Wenn diese Option aktiviert ist, wird die Tabelle in HTML-Tabellen und maximal 256 Zeilen für eine Tabelle analysiert. Andernfalls wird es zeilenweise in Schlüssel-Wert-Paare analysiert.`,
      autoKeywords: 'Automatisches Schlüsselwort',
      autoKeywordsTip: `Extrahieren Sie automatisch N Schlüsselwörter für jeden Chunk, um sein Ranking für Suchanfragen, die diese Schlüsselwörter enthalten, zu verbessern. Sie können die hinzugefügten Schlüsselwörter für einen Chunk in der Chunk-Liste überprüfen oder aktualisieren. Beachten Sie, dass zusätzliche Token vom LLM verbraucht werden, das in 'Systemmodelleinstellungen' angegeben ist.`,
      autoQuestions: 'Automatische Frage',
      autoQuestionsTip: `Automatisches Extrahieren von N Fragen für jeden Chunk, um das Ranking für Abfragen, die diese Fragen enthalten, zu verbessern. Sie können die hinzugefügten Fragen für einen Chunk in der Chunk-Liste überprüfen oder aktualisieren. Diese Funktion unterbricht den Chunking-Prozess nicht, wenn ein Fehler auftritt, außer dass sie dem ursprünglichen Chunk ein leeres Ergebnis hinzufügen kann. Beachten Sie, dass zusätzliche Token von dem in 'Systemmodelleinstellungen' angegebenen Sprachmodell verbraucht werden.`,
      redo: 'Möchten Sie die vorhandenen {{chunkNum}}-Chunks löschen?',
      username: 'Benutzername',
      password: 'Passwort',
      rowItemsSelected: 'Dateien ausgewählt',
      selectAllRows: 'Alle Dateien auswählen',
      selectAllMatchingRows: 'Alle passenden Dateien auswählen',
      clearFilters: 'Filter zurücksetzen',
      unselectAllRows: 'Auswahl aufheben',
      tag: 'Taggen',
      authentication: 'Authentifizierung',
      formLogin: 'Formular-Login',
      loginUrl: 'Login-URL',
      usernameField: 'Benutzername-Feld',
      passwordField: 'Passwort-Feld',
      logoutUrlPatterns: 'Logout-URL-Muster',
      crawlSettings: 'Crawl-Einstellungen',
      extendedSettings: 'Erweiterte Einstellungen',
      markdownGeneratorOptions: 'Markdown Generator Optionen',
      discoveryMode: 'Link-Erkennung',
      discoveryModeDeep: 'Deep Crawl (Links folgen)',
      discoveryModeSitemap: 'Sitemap',
      discoveryModeUrlList: 'URL-Liste',
      sitemapUrl: 'Sitemap-URL',
      sitemapUrlTooltip:
        'URL einer XML-Sitemap. Die darin (und in referenzierten Unter-Sitemaps) aufgeführten Seiten werden gecrawlt.',
      urlList: 'URLs',
      urlListTooltip:
        'Die genaue Menge der zu crawlenden URLs — kein Link-Folgen, kein Sitemap-Abruf, keine Erkennung jeglicher Art. Mehrere URLs durch Kommas oder Zeilenumbrüche getrennt einfügen.',
      urlListInvalidEntry: '„{{url}}“ ist keine gültige http(s)-URL',
      urlListTooManyEntries:
        'Eine URL-Liste darf nicht mehr als {{max}} URLs enthalten',
      respectSitemapLastmod:
        'Unveränderte Seiten überspringen (Sitemap lastmod)',
      respectSitemapLastmodTooltip:
        'Bei erneuten Crawls Seiten überspringen, deren Sitemap-<lastmod> nicht neuer ist als der letzte erfasste Stand. Deaktivieren, um einen vollständigen Neu-Crawl zu erzwingen.',
      downloadLinkedPdfs: 'Verlinkte PDFs herunterladen',
      downloadLinkedPdfsTooltip:
        'Auch PDFs herunterladen, die auf den gecrawlten Seiten verlinkt sind, nicht nur die in der Sitemap aufgeführten URLs. Anderen Links wird nicht gefolgt.',
      includeExternalRedirectTargets: 'Externe Redirect-Ziele einbeziehen',
      includeExternalRedirectTargetsTooltip:
        'Nur relevant, wenn "Exclude External Links" aktiv ist. Ein Link, der intern aussieht, kann beim Abruf trotzdem auf eine andere Domain umleiten; die Linkerkennung von dieser Seite aus wird immer blockiert, sobald sie außerhalb dieser Domain landet. Diese Einstellung steuert nur, ob die Zielseite der Umleitung selbst noch als Dokument erfasst wird.',
      max_depth: {
        minimum_message: 'Die maximale Tiefe muss größer gleich 0 sein',
        placeholder: 'z.B. 10',
      },
      max_pages: {
        minimum_message: 'Die maximale Seitenzahl muss größer als 0 sein',
        placeholder: 'z.B. 10000',
      },
    },
    knowledgeConfiguration: {
      titleDescription:
        'Aktualisieren Sie hier Ihre Wissensdatenbankkonfiguration, insbesondere die Chunk-Methode.',
      name: 'Name der Wissensdatenbank',
      photo: 'Foto der Wissensdatenbank',
      description: 'Beschreibung',
      language: 'Sprache',
      languageMessage: 'Bitte geben Sie Ihre Sprache ein!',
      languagePlaceholder: 'Bitte geben Sie Ihre Sprache ein!',
      permissions: 'Berechtigungen',
      embeddingModel: 'Einbettungsmodell',
      chunkTokenNumber: 'Chunk-Token-Nummer',
      chunkTokenNumberMessage: 'Chunk-Token-Nummer ist erforderlich',
      embeddingModelTip:
        'Das Modell, das Chunks in Einbettungen umwandelt. Es kann nicht mehr geändert werden, sobald die Wissensdatenbank Teile enthält. Um zu einem anderen Einbettungsmodell zu wechseln, müssen Sie alle vorhandenen Blöcke in der Wissensdatenbank löschen.',
      permissionsTip:
        "Wenn auf 'Team' gestellt, können alle Teammitglieder an der Wissensdatenbank arbeiten.",
      chunkTokenNumberTip:
        'Es legt den Token-Schwellenwert für einen Block fest. Ein Absatz mit weniger Token als dieser Schwellenwert wird mit dem folgenden Absatz kombiniert, bis die Tokenanzahl den Schwellenwert überschreitet. Anschließend wird ein Block erstellt.',
      chunkMethod: 'Chunk-Methode',
      chunkMethodTip: 'Sehen Sie sich die Tipps rechts an.',
      replaceSameDocName: 'Gleichnamige Dokumente ersetzen',
      replaceSameDocNameTip:
        'Beim Dokumenten-Upload werden bereits vorhandene Dokumente gleichen Namens ersetzt.',
      imageDescription: 'Bilder analysieren',
      imageDescriptionTip:
        'Bilder vor dem Chunking von einem Vision-Modell beschreiben lassen. Gilt für Bilder und Diagramme in PDFs sowie für Bilder in gecrawlten Webseiten. Änderungen wirken nur auf ab jetzt verarbeitete Dokumente.',
      imageDescriptionPrompt: 'Bildbeschreibungsprompt',
      imageDescriptionPromptTip:
        'Leer lassen, um den Standard-Prompt zu verwenden. Die Anweisung, bei belanglosen Bildern mit der festen Kennzeichnung zu antworten, wird immer ergänzt – so werden solche Bilder weiterhin aus den Chunks entfernt.',
      // Keep in sync with DEFAULT_IMAGE_DESCRIPTION_PROMPT in rag/llm/cv_model.py.
      imageDescriptionPromptPlaceholder: `Beurteile, ob das folgende Bild wesentliche, interpretierbare Informationen enthält.
Fasse die wichtigsten Punkte auf Deutsch zusammen, wenn das Bild detaillierte Daten oder klare Zusammenhänge darstellt.
Du musst keinen einleitenden Text schreiben, wenn das Bild wesentliche Informationen beinhaltet, sondern starte in deiner Antwort direkt mit dem Inhalt.`,
      imageDescriptionNoModelWarning:
        'In den System-Modelleinstellungen ist kein Img2txt-Modell hinterlegt. Bilder werden erst beschrieben, wenn eines gesetzt ist.',
      imageDescriptionNoModelLink: 'Modelleinstellungen öffnen',
      imageDescriptionContextBefore: 'Kontext vor dem Bild (Zeichen)',
      imageDescriptionContextAfter: 'Kontext nach dem Bild (Zeichen)',
      imageDescriptionContextTip:
        'Wie viel umgebender Dokumenttext dem Vision-Modell als Kontext mitgegeben wird. 0 deaktiviert den Kontext.',
      upload: 'Hochladen',
      english: 'Englisch',
      german: 'Deutsch',
      chinese: 'Chinesisch',
      embeddingModelPlaceholder: 'Bitte wählen Sie ein Einbettungsmodell aus',
      chunkMethodPlaceholder: 'Bitte wählen Sie eine Chunk-Methode aus',
      save: 'Speichern',
      me: 'Nur ich',
      team: 'Team',
      cancel: 'Abbrechen',
      methodTitle: 'Beschreibung der Chunk-Methode',
      methodExamples: 'Beispiele',
      methodExamplesDescription:
        'Zur Verdeutlichung dienen die folgenden Screenshots.',
      dialogueExamplesTitle: 'Dialogbeispiele',
      methodEmpty:
        'Dadurch wird eine visuelle Erläuterung der Wissensdatenbankkategorien angezeigt',
      book: `<p>Unterstützte Dateiformate sind <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
        Für jedes Buch im PDF-Format legen Sie bitte die <i>Seitenbereiche</i> fest, um unerwünschte Informationen zu entfernen und die Analysezeit zu reduzieren.</p>`,
      laws: `<p>Unterstützte Dateiformate sind <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
        Rechtliche Dokumente folgen in der Regel einem strengen Schreibformat. Wir nutzen Textmerkmale, um den Teilungspunkt zu identifizieren. 
        </p><p>
        Die Granularität des Segments ist konsistent mit 'ARTIKEL', sodass alle übergeordneten Texte im Segment enthalten sind.
        </p>`,
      manual: `<p>Nur <b>PDF</b> wird unterstützt.</p><p>
        Wir gehen davon aus, dass das Handbuch eine hierarchische Abschnittsstruktur hat und die niedrigsten Abschnittstitel als Grundeinheit zur Segmentierung von Dokumenten verwendet werden. Daher werden Figuren und Tabellen im selben Abschnitt nicht getrennt, was zu größeren Segmentgrößen führen kann.
        </p>`,
      naive: `<p>Unterstützte Dateiformate sind <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML, HTML</b>.</p>
        <p>Diese Methode segmentiert Dateien mit einer 'naiven' Methode: </p>
        <p>
        <li>Verwenden Sie ein Visionsmodell, um die Texte in kleinere Abschnitte zu unterteilen.</li>
        <li>Kombinieren Sie anschließend angrenzende Abschnitte, bis die Tokenanzahl den durch 'Chunk-Token-Nummer' festgelegten Schwellenwert überschreitet, woraufhin ein Segment erstellt wird.</li></p>`,
      paper: `<p>Nur <b>PDF</b>-Dateien werden unterstützt.</p><p>
        Dokumente werden nach Abschnitten wie <i>Abstract, 1.1, 1.2</i> aufgeteilt. </p><p>
        Dieser Ansatz ermöglicht es dem LLM, das Papier effektiver zusammenzufassen und umfassendere, verständlichere Antworten zu geben. 
        Dies erhöht jedoch auch den Kontext für KI-Gespräche und den Rechenaufwand für das LLM. Ziehen Sie daher während eines Gesprächs in Betracht, den Wert von '<b>topN</b>' zu reduzieren.</p>`,
      presentation: `<p>Unterstützte Dateiformate sind <b>PDF</b>, <b>PPTX</b>.</p><p>
        Jede Seite in den Folien wird als Segment behandelt, mit ihrem Thumbnail-Bild gespeichert.</p><p>
        <i>Diese Segmentierungsmethode wird automatisch auf alle hochgeladenen PPT-Dateien angewendet, sodass Sie sie nicht manuell angeben müssen.</i></p>`,
      qa: `
        <p>
        Diese Segmentierungsmethode unterstützt die Dateiformate <b>EXCEL</b> und <b>CSV/TXT</b>.
        </p>
        <li>
          Wenn eine Datei im <b>Excel</b>-Format vorliegt, sollte sie zwei Spalten ohne Kopfzeilen enthalten: eine für Fragen und die andere für Antworten, wobei die Fragenspalte vor der Antwortspalte steht. Mehrere Blätter sind zulässig, sofern die Spalten richtig strukturiert sind.
        </li>
        <li>
          Wenn eine Datei im <b>CSV/TXT</b>-Format vorliegt, muss sie UTF-8-codiert sein, mit TAB als Trennzeichen zwischen Fragen und Antworten.
        </li>
        <p>
          <i>
            Zeilen, die den oben genannten Regeln nicht folgen, werden ignoriert, und jedes Q&A-Paar wird als separates Segment betrachtet.
          </i>
        </p>
        `,
      resume: `<p>Unterstützte Dateiformate sind <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
        </p><p>
        Lebensläufe in verschiedenen Formen werden analysiert und in strukturierte Daten organisiert, um die Kandidatensuche für Personalvermittler zu erleichtern.
        </p>
        `,
      table: `<p>Unterstützte Dateiformate sind <b>EXCEL</b> und <b>CSV/TXT</b>.</p><p>
        Hier sind einige Voraussetzungen und Tipps:
        <ul>
      <li>Für CSV- oder TXT-Dateien muss das Trennzeichen zwischen den Spalten <em><b>TAB</b></em> sein.</li>
      <li>Die erste Zeile muss Spaltenüberschriften enthalten.</li>
      <li>Spaltenüberschriften sollten sinnvolle Begriffe sein, um das Verständnis Ihres LLM zu unterstützen.
      Es ist eine gute Praxis, Synonyme mit einem Schrägstrich <i>'/'</i> zu kombinieren und Werte in Klammern aufzulisten, z. B.: <i>'Geschlecht/Geschlecht (männlich, weiblich)'</i>.<p>
      Hier sind einige Beispiele für Überschriften:<ol>
          <li>Lieferant/Anbieter<b>'TAB'</b>Farbe (Gelb, Blau, Braun)<b>'TAB'</b>Geschlecht (männlich, weiblich)<b>'TAB'</b>Größe (M, L, XL, XXL)</li>
          </ol>
          </p>
      </li>
      <li>Jede Zeile in der Tabelle wird als Segment behandelt.</li>
      </ul>`,
      picture: `
      <p>Bilddateien werden unterstützt, Videounterstützung folgt in Kürze.</p><p>
      Diese Methode verwendet ein OCR-Modell, um Texte aus Bildern zu extrahieren.
      </p><p>
      Falls der durch das OCR-Modell extrahierte Text als unzureichend angesehen wird, wird ein spezielles visuelles LLM verwendet, um eine Beschreibung des Bildes bereitzustellen.
      </p>`,
      one: `
      <p>Unterstützte Dateiformate sind <b>DOCX, EXCEL, PDF, TXT</b>.
      </p><p>
      Diese Methode behandelt jedes Dokument in seiner Gesamtheit als ein Segment.
      </p><p>
      Dies ist anwendbar, wenn Sie vom LLM verlangen, das gesamte Dokument zusammenzufassen, sofern es diese Kontextgröße verarbeiten kann.
      </p>`,
      knowledgeGraph: `<p>Unterstützte Dateiformate sind <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>
      
      <p>Dieser Ansatz segmentiert Dateien mit der 'naiv'/'Allgemein'-Methode. Er teilt ein Dokument in Abschnitte und kombiniert angrenzende Abschnitte, bis die Tokenanzahl den durch 'Chunk-Token-Nummer' festgelegten Schwellenwert überschreitet, woraufhin ein Segment erstellt wird.</p>
      <p>Die Segmente werden dann dem LLM zugeführt, um Entitäten und Beziehungen für einen Wissensgraphen und eine Gedankenkarte zu extrahieren.</p>
      <p>Stellen Sie sicher, dass Sie die <b>Entitätstypen</b> festlegen.</p>`,
      tag: `<p>Eine Wissensbasis, die die Segmentierungsmethode 'Tag' verwendet, soll von anderen Wissensbasen verwendet werden, um Tags zu deren Segmenten hinzuzufügen. Anfragen an diese Wissensbasis erfolgen ebenfalls mit Tags.</p>
      <p>Eine Wissensbasis, die die Segmentierungsmethode 'Tag' verwendet, soll <b>NICHT</b> im RAG-Verfahren eingebunden sein.</p>
      <p>Die Segmente in dieser Wissensbasis sind Beispiele für Tags, die den gesamten Tag-Satz und die Relevanz zwischen Segment und Tags demonstrieren.</p>
      
      <p>Diese Segmentierungsmethode unterstützt die Dateiformate <b>EXCEL</b> und <b>CSV/TXT</b>.</p>
      <p>Wenn eine Datei im <b>Excel</b>-Format vorliegt, sollte sie zwei Spalten ohne Kopfzeilen enthalten: eine für den Inhalt und die andere für Tags, wobei die Inhaltsspalte vor der Tagsspalte steht. Mehrere Blätter sind zulässig, sofern die Spalten richtig strukturiert sind.</p>
      <p>Wenn eine Datei im <b>CSV/TXT</b>-Format vorliegt, muss sie UTF-8-codiert sein, mit TAB als Trennzeichen zwischen Inhalt und Tags.</p>
      <p>In der Tags-Spalte gibt es englische <b>Kommas</b> zwischen den Tags.</p>
      <i>Zeilen, die den oben genannten Regeln nicht folgen, werden ignoriert, und jedes Paar wird als separates Segment betrachtet.</i>
      `,
      useRaptor: 'Verwenden Sie RAPTOR, um das Abrufen zu verbessern',
      useRaptorTip:
        'Rekursive abstrakte Verarbeitung für baumorganisiertes Abrufen, siehe https://huggingface.co/papers/2401.18059 für weitere Informationen.',
      prompt: 'Prompt',
      promptTip: 'Sprachmodell-Eingabeaufforderung zur Zusammenfassung.',
      promptMessage: 'Prompt ist erforderlich',
      promptText: `Bitte fassen Sie die folgenden Absätze zusammen. Seien Sie vorsichtig mit den Zahlen, erfinden Sie keine Dinge. Absätze wie folgt:
      {cluster_content}
Der obige Text ist der Inhalt, den Sie zusammenfassen müssen.`,
      maxToken: 'Max-Token',
      maxTokenTip: 'Maximale Tokenanzahl für die Zusammenfassung.',
      maxTokenMessage: 'Max-Token ist erforderlich',
      threshold: 'Schwelle',
      thresholdTip:
        'Je größer der Schwellenwert ist, desto weniger Cluster wird es geben.',
      thresholdMessage: 'Schwellenwert ist erforderlich',
      maxCluster: 'Maximaler Cluster',
      maxClusterTip: 'Maximale Clusteranzahl.',
      maxClusterMessage: 'Maximaler Cluster ist erforderlich',
      randomSeed: 'Zufälliger Samen',
      randomSeedMessage: 'Zufälliger Seed ist erforderlich',
      entityTypes: 'Entitätstypen',
      vietnamese: 'Vietnamesisch',
      pageRank: 'Seitenrang',
      pageRankTip: `Dadurch erhöht sich der Relevanzwert der Wissensdatenbank. Sein Wert wird zum Relevanzwert aller abgerufenen Teile dieser Wissensdatenbank addiert. Nützlich, wenn Sie in mehreren Wissensdatenbanken suchen und einer bestimmten Datenbank einen höheren Pagerank-Score zuweisen möchten.`,
      tagName: 'Tag',
      frequency: 'Frequenz',
      searchTags: 'Suchtags',
      tagCloud: 'Wolke',
      tagTable: 'Tisch',
      tagSet: 'Tag set',
      tagSetTip: `
     <p> Selecting the 'Tag' knowledge bases helps to tag every chunks. </p>
<p>Query to those chunks will also be with tags too.</p>
This procedure will improve precision of retrieval by adding more information to the dataset, especially when there's a large set of chunks.
<p>Difference between tags and keywords:</p>
<ul>
  <li>Tag is a close set which is defined and manipulated by user while keyword is an open set.</li>
  <li>You need to upload tag sets with samples prior to use.</li>
  <li>Keywords are generated by LLM which is expensive and time consuming.</li>
</ul>
      `,
      topnTags: 'Top-N-Tags',
    },
    chunk: {
      chunk: 'Chunk',
      bulk: 'Liste',
      selectAll: 'Wählen Sie „Alle“ aus',
      enabledSelected: 'Ausgewählte aktivieren',
      disabledSelected: 'Ausgewählte Option deaktivieren',
      deleteSelected: 'Ausgewählte löschen',
      search: 'Suchen',
      all: 'Alle',
      enabled: 'Ermöglicht',
      disabled: 'Deaktiviert',
      keyword: 'Stichwort',
      function: 'Funktion',
      chunkMessage: 'Bitte Wert eingeben!',
      full: 'Volltext',
      ellipse: 'Kurzform',
      graph: 'Wissensgraph',
      mind: 'Mindmap',
      question: 'Frage',
      questionTip: `If there're given questions, the embedding of the chunk will be based on them.`,
    },
    memberInvites: {
      back: 'Zurück',
      landingTitle: 'Einladung zu einem Buddy',
      landingBody:
        'Diese Einladung wird in der Buddy-App eingelöst und gilt nur für ein Gerät.',
      landingOpen: 'In der Buddy-App öffnen',
      landingHelp:
        'Passiert nichts? Installiere die Buddy-App aus dem App Store oder Google Play, öffne diesen Link danach erneut — oder scanne den QR-Code der Einladung in der App.',
      landingInvalid:
        'Dieser Einladungslink ist unvollständig. Bitte öffne den Link genau so, wie du ihn erhalten hast.',
      menuEntry: 'App-Mitglieder',
      title: 'App-Mitglieder & Einladungen',
      inviteMember: 'Neues Mitglied einladen',
      featureOffTitle: 'App-Einladungen sind ausgeschaltet',
      featureOffDescription:
        'Schalten Sie „App-Einladungen“ in den Einstellungen dieses Buddys ein, um neue Einladungen zu verschicken. Bestehende Mitglieder können den Buddy nicht nutzen, solange die Option aus ist.',
      tabMembers: 'Mitglieder',
      tabInvites: 'Einladungen',
      label: 'Name / Notiz',
      labelTip:
        'Für wen die Einladung ist, damit Sie Mitglieder unterscheiden können. Nur für Sie sichtbar, nie für das Mitglied.',
      labelPlaceholder: 'z. B. Frau Müller, Physiogruppe A',
      unnamed: '(ohne Namen)',
      createTitle: 'Neues Mitglied einladen',
      create: 'Einladungslink erstellen',
      status: 'Status',
      status_active: 'Aktiv',
      status_revoked: 'Gesperrt',
      status_open: 'Offen',
      status_redeemed: 'Eingelöst',
      status_expired: 'Abgelaufen',
      revokedOn: 'Gesperrt am {{date}}',
      devices: 'Geräte',
      deviceCount: '{{active}} aktiv',
      device: 'Gerät',
      platform_android: 'Android',
      platform_ios: 'iOS',
      attestation: 'Schlüsselspeicher',
      attestation_STRONGBOX: 'StrongBox',
      attestation_TEE: 'Sichere Hardware',
      attestation_SECURE_ENCLAVE: 'Secure Enclave',
      attestation_SOFTWARE: 'Nicht geprüft',
      attestationSoftwareTip:
        'Dieses Gerät konnte nicht nachweisen, dass sein Schlüssel in sicherer Hardware liegt. Es wurde nur zugelassen, weil der Server im Testmodus läuft.',
      enrolled: 'Registriert',
      lastSeen: 'Letzter Zugriff',
      never: 'nie',
      created: 'Erstellt',
      expiresAt: 'Gültig bis',
      kind: 'Art',
      kind_new_member: 'Neues Mitglied',
      kind_add_device: 'Weiteres Gerät für {{label}}',
      addDevice: 'Gerät hinzufügen',
      revokeAccess: 'Zugang sperren',
      deleteMember: 'Löschen',
      revokeDevice: 'Gerät entfernen',
      revokeInvite: 'Zurückziehen',
      revokeMemberConfirmTitle: 'Zugang für {{label}} sperren?',
      revokeMemberConfirmContent:
        'Alle Geräte dieses Mitglieds verlieren sofort den Zugang, und offene Einladungen werden zurückgezogen. Die Chat-Historie bleibt erhalten, und Sie können das Mitglied später mit einer neuen Geräte-Einladung wieder freischalten.',
      deleteMemberConfirmTitle: '{{label}} endgültig löschen?',
      deleteMemberConfirmContent:
        'Das Mitglied, seine Geräte, alle seine Unterhaltungen mit diesem Buddy und die darin hochgeladenen Dokumente werden gelöscht. Das lässt sich nicht rückgängig machen.',
      revokeDeviceConfirmTitle: '{{device}} entfernen?',
      revokeDeviceConfirmContent:
        'Das Gerät verliert sofort den Zugang. Das Mitglied behält seine anderen Geräte und seine Chat-Historie.',
      revokeInviteConfirmTitle: 'Einladung zurückziehen?',
      revokeInviteConfirmContent: 'Der Link funktioniert ab sofort nicht mehr.',
      revealTitle: 'Einladung für {{label}}',
      revealDeviceTitle: 'Weiteres Gerät für {{label}}',
      revealOnce: 'Link jetzt kopieren oder teilen',
      revealOnceDescription:
        'Aus Sicherheitsgründen wird der Link nur einmal angezeigt. Er ist gültig bis {{date}} und kann genau einmal auf einem Gerät eingelöst werden. Geht er verloren, ziehen Sie ihn zurück und erstellen einen neuen.',
      revealLink: 'Einladungslink',
      revealQr: 'Mit der Buddy-App oder der Handykamera scannen',
      revealDone: 'Fertig',
      emptyMembers:
        'Noch keine Mitglieder. Laden Sie jemanden ein, um loszulegen.',
      emptyInvites: 'Noch keine Einladungen.',
      featureDisabled:
        'App-Einladungen sind für diesen Buddy ausgeschaltet. Schalten Sie sie zuerst in den Einstellungen ein.',
      deviceLimitReached:
        'Dieses Mitglied hat die maximale Anzahl an Geräten erreicht (offene Einladungen mitgezählt). Entfernen Sie zuerst ein Gerät oder ziehen Sie eine offene Einladung zurück.',
      memberNotFound: 'Dieses Mitglied existiert nicht mehr.',
      deviceNotFound: 'Dieses Gerät existiert nicht mehr.',
      inviteNotFound: 'Diese Einladung existiert nicht mehr.',
    },
    chat: {
      recencyBoost: 'Neuere Dokumente bevorzugen',
      recencyBoostTip:
        'Bevorzugt bei der Suche Dokumente mit neuerem Erscheinungsjahr. Wirkt nur auf Dokumente, bei denen ein Erscheinungsjahr hinterlegt ist; Dokumente ohne Jahr werden nie zurückgestuft. Sinnvoll, wenn eine Wissensdatenbank mehrere Fassungen derselben Leitlinie enthält.',
      recencyBoostOff: 'Aus',
      recencyBoostLight: 'Leicht',
      recencyBoostStrong: 'Stark',
      // Fortschritt einer agentischen Antwort, während sie erzeugt wird.
      agentStepsLabel: 'Fortschritt',
      agentStepThinking: 'Denke nach…',
      agentStepThinkingDone: 'Nachgedacht',
      agentStepTool: 'Verwende ein Werkzeug…',
      agentStepToolDone: 'Werkzeug verwendet',
      agentStepConsulting: 'Frage {{name}}…',
      agentStepConsultingDone: '{{name}} gefragt',
      agentStepSearching: 'Durchsuche die Wissensdatenbank…',
      agentStepSearchingDone: 'Wissensdatenbank durchsucht',
      agentStepSearchingDoneCount_one:
        'Wissensdatenbank durchsucht · {{count}} relevante Stelle gefunden',
      agentStepSearchingDoneCount_other:
        'Wissensdatenbank durchsucht · {{count}} relevante Stellen gefunden',
      agentStepWebsearch: 'Durchsuche das Web…',
      agentStepWebsearchDone: 'Web durchsucht',
      agentStepBrowsing: 'Sichte die Dokumente…',
      agentStepBrowsingDone: 'Dokumente gesichtet',
      agentStepReading: 'Lese ein Dokument…',
      agentStepReadingDone: 'Dokument gelesen',
      agentStepFailed:
        'Ein Schritt hat nicht funktioniert – es geht mit den vorhandenen Informationen weiter',
      formValidationError: 'Bitte korrigieren Sie die Fehler im Formular.',
      newConversation: 'Neues Gespräch',
      createAssistant: 'Erstellen Sie einen Assistenten',
      exportEvaluation: {
        title: 'Chatverläufe exportieren',
        description:
          'Exportiert Chatverläufe in eine Datei. Enthält alle von Benutzern gesendeten Nachrichten, die Antworten des Chatbots und das Feedback der Nutzer.',
        downloadError: 'Export fehlgeschlagen: {{error}}',
        preparing:
          'Export wird vorbereitet und steht gleich zum Download zur Verfügung …',
        ready: 'Export fertig – die Datei liegt in Ihren Downloads.',
        failed: 'Export fehlgeschlagen. Bitte versuchen Sie es erneut.',
        busy: 'Gerade laufen zu viele Exporte. Bitte versuchen Sie es in ein paar Minuten erneut.',
        cancelled: 'Sie haben den Export abgebrochen.',
        disconnected:
          'Die Verbindung ist abgerissen, der Export wurde gestoppt.',
        restart: 'Neu starten',
        cancel: 'Export abbrechen',
        toastTitle: '{{format}}-Export wird erstellt',
        finishing: 'Datei wird fertiggestellt …',
        otherExportRunning:
          'Es läuft bereits ein Export eines anderen Chatbots. Warten Sie, bis er fertig ist, oder brechen Sie ihn ab.',
        alreadyRunning: 'Für diesen Chatbot läuft bereits ein Export.',
        progress: '{{done}} von {{total}} Sitzungen verarbeitet',
        csv: 'Download CSV',
        xlsx: 'Download XLSX',
        runningHint:
          'Sie können dieses Fenster schließen oder die Seite verlassen – der Download läuft im Browser weiter, der Fortschritt bleibt in der Ecke sichtbar.',
        filterDateRange: 'Datumsbereich filtern',
      },
      assistantSetting: 'Assistent',
      pleaseSetSttModel:
        'Bitte zuerst ein Speech2txt-Modell festlegen. Einstellungen >> Modellanbieter >> Systemmodelleinstellungen.',
      pleaseSetTtsModel:
        'Bitte zuerst ein TTS-Modell festlegen. Einstellungen >> Modellanbieter >> Systemmodelleinstellungen.',
      pleaseSetDiarizationModel:
        'Bitte zuerst ein Diarisierungsmodell festlegen. Einstellungen >> Modellanbieter >> Systemmodelleinstellungen.',
      designSetting: 'Design',
      contentSetting: 'Inhalte',
      promptEngine: 'Prompt-Engine',
      modelSetting: 'Modell',
      chat: 'Chat',
      newChat: 'Neuer Chat',
      send: 'Senden',
      sendPlaceholder: 'Deine Frage...',
      footerDisclaimer:
        'Buddy kann Fehler machen. Nutzung auf eigene Gefahr. [Innovative Gesundheit by ZTM](https://www.ztm.de/buddy).',
      languageSelectTitle: 'Sprache auswählen',
      chatConfiguration: 'Chat-Konfiguration',
      chatConfigurationDescription:
        'Richten Sie hier einen Chat-Assistenten für Ihre ausgewählten Wissensdatenbanken ein!',
      general: 'Identität',
      assistantName: 'Name',
      assistantNameMessage: 'Der Name des Assistenten ist erforderlich',
      namePlaceholder: 'z.B. Buddy',
      descriptionPlaceholder:
        'z.B. erklärt Inhalte aus der Gesundheits-Datenbank',
      assistantAvatar: 'Icon',
      interaction: 'Interaktion',
      language: 'Hauptsprache',
      languageTip: 'Hauptsprache des Chat-Assistenten.',
      languageSelection: 'Sprachauswahl aktivieren',
      languageSelectionTip:
        'Entscheiden Sie, ob der Benutzer die Sprache während des Chats ändern kann.',
      autofocusInput: 'Eingabefeld beim Öffnen fokussieren',
      autofocusInputTip:
        'Entscheiden Sie, ob der Cursor beim Öffnen des Chats direkt im Eingabefeld steht, sodass Benutzer sofort tippen können. Deaktivieren Sie dies, damit auf Mobilgeräten nicht automatisch die Tastatur aufgeht.',
      emptyResponse: 'Leere Antwort',
      emptyResponseTip: `Legen Sie dies als Antwort fest, wenn für Ihre Abfrage keine Ergebnisse aus den Wissensdatenbanken abgerufen werden, oder lassen Sie dieses Feld leer, damit das LLM improvisieren kann, wenn nichts gefunden wird.`,
      enableOpener: 'Begrüßung aktivieren',
      enableOpenerTip:
        'Entscheiden Sie, ob eine Begrüßungsnachricht angezeigt werden soll, wenn der Chat gestartet wird.',
      setAnOpener: 'Begrüßung',
      setAnOpenerInitial: `Hallo! Ich bin Ihr Assistent, was kann ich für Sie tun?`,
      setAnOpenerTip: 'Legen Sie eine Eröffnungsbegrüßung für Benutzer fest.',
      showSuggestedQuestions: 'Folgefragen vorschlagen',
      showSuggestedQuestionsTip:
        'Entscheiden Sie, ob Vorschläge für Folgefragen angezeigt werden sollen, um den Chat nach Antwort des Chatbots fortzusetzen.',
      showSuggestedQuestionsOnStartup: 'Beim Start anzeigen',
      showSuggestedQuestionsOnStartupTip:
        'Entscheiden Sie, ob Vorschläge für Folgefragen beim Start des Chats angezeigt werden sollen.',
      misc: 'Sonstiges',
      citation: 'Quellenangabe',
      restrictAccess: 'Zugriff einschränken',
      restrictAccessTip:
        'Legen Sie fest, ob der Zugriff auf diesen Chat-Assistenten auf bestimmte IP-Adressen oder Benutzer beschränkt werden soll.',
      userAuthentication: 'Benutzerauthentifizierung',
      userAuthenticationTip:
        'Anfragen müssen einen Token vorlegen, der mit dem entsprechenden Private Key signiert wurde; Tokens werden mit dem konfigurierten Public Key verifiziert.',
      deviceInvites: 'App-Einladungen',
      deviceInvitesTip:
        'Laden Sie einzelne Personen mit einem Einmal-Link ein, diesen Buddy in der Buddy-App zu nutzen. Jede Person erhält Zugang nur auf ihrem eigenen Gerät; der Zugang lässt sich nicht auf ein anderes Gerät kopieren.',
      deviceInvitesHint:
        'Nach dem Speichern verwalten Sie Mitglieder und Einladungslinks über das ⋯-Menü dieses Buddys → „App-Mitglieder“. Für App-Mitglieder gilt die IP-Beschränkung nicht.',
      allowedIps: 'Zugelassene IPs',
      allowedIpsTip:
        'Legen Sie die zulässigen IP-Adressen fest, die auf diesen Chat-Assistenten zugreifen dürfen. Lassen Sie dieses Feld leer, um den Zugriff für alle IP-Adressen zu ermöglichen.',
      invalidIp: 'Ungültiges IP-Format',
      allowedIpsPlaceholder: 'z.B. 192.168.1.1',
      publicKey: 'Public Key',
      publicKeyTip:
        'Legen Sie einen Public Key fest, anhand dessen die Tokens von Nutzern Ihres Systems authentifiziert werden können. Ihr System muss dazu Tokens mit dem dazugehörigen Private Key erzeugen können.',
      privateKey: 'Private Key',
      publicKeyRequired: 'Public Key ist erforderlich',
      showChatHistory: 'Chat-Historie anzeigen',
      showChatHistoryTooltip:
        'Erlaubt es dem Benutzer, den Verlauf seiner vergangener Chats in einer Sidebar anzuzeigen.',
      showChatHistoryNeedsSaving:
        'Setzt gespeicherte Unterhaltungen voraus. Aktivieren Sie „Unterhaltungen speichern“, um die Chat-Historie zu nutzen.',
      saveConversations: 'Unterhaltungen speichern',
      saveConversationsTip:
        'Speichert die Unterhaltungen dieses Chatbots. Ist die Option deaktiviert, existiert eine Unterhaltung nur, solange sie geführt wird, und wird nie in die Datenbank geschrieben: keine Chat-Historie, keine Feedback-Buttons, keine Daten auf der Auswertungsseite und kein Export. Bereits gespeicherte Unterhaltungen bleiben erhalten.',
      generateKeyPair: 'Neues Key Pair generieren',
      generateKeyPairDescription:
        'Möchten Sie ein neues Schlüsselpaar generieren?\nDer private Schlüssel wird nur einmalig angezeigt.\nStellen Sie sicher, dass Sie ihn an einem sicheren Ort speichern und geheim halten.',
      copyPrivateKey: 'Kopieren',
      reportingEnabled: 'Reporting an',
      reportingEnabledTip:
        'Aktivieren Sie einen wöchentlichen Auswertungsreport zu ihrem Buddy per E-Mail',
      reportingEmailAddresses: 'E-Mail-Adressen',
      reportingEmailAddressesTip:
        'Geben Sie die E-Mail-Adressen an, an die der Report geschickt werden soll.',
      reportingEmailAddressesPlaceholder: 'z.B. peter@lustig.de',
      reportingCycle: 'Reporting-Intervall',
      reportingCycleTip:
        'Bestimmen Sie, in welchem Intervall die Reports generiert und verschickt werden.',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      showDisclaimer: 'Disclaimer anzeigen',
      showDisclaimerTip:
        'Entscheiden Sie, ob Sie einen Disclaimer vor erstmaliger Nutzung des Chats anzeigen lassen wollen.',
      disclaimerTitle: 'Titel des Disclaimers',
      disclaimerTitleTip: 'Legen Sie den Titel des Disclaimer fest.',
      disclaimerText: 'Inhalt des Disclaimers',
      disclaimerTextTip:
        'Bestimmen Sie den Inhalt, der im Disclaimer angezeigt werden soll.',
      positiveFeedbackTitle: 'Titel positives Feedback',
      positiveFeedbackTitleTip:
        'Legen Sie den Titel und Text für das positive Feedback fest.',
      positiveFeedbackText: 'Text positives Feedback',
      positiveFeedbackTextTip:
        'Bestimmen Sie den Text, der im positiven Feedback angezeigt werden soll.',
      positiveFeedbackDefaultTitle: 'Feedback senden',
      positiveFeedbackDefaultText:
        'Vielen Dank für das Feedback! Gerne können Sie uns auch optional noch einen Kommentar hinterlassen.',
      negativeFeedbackTitle: 'Titel negatives Feedback',
      negativeFeedbackTitleTip:
        'Legen Sie den Titel für das negative Feedback fest.',
      negativeFeedbackText: 'Text negatives Feedback',
      negativeFeedbackTextTip:
        'Bestimmen Sie den Text, der im negativen Feedback angezeigt werden soll.',
      negativeFeedbackDefaultTitle: 'Problem melden',
      negativeFeedbackDefaultText:
        'Die Antwort ist nicht in Ordnung? Bitte geben Sie an, welcher Art das Problem ist. Wir werden uns dann diese eine Chat-Session anonymisiert ansehen.',
      design: 'Design',
      themeTypography: 'Thema & Typografie',
      backgroundColor: 'Chat-Hintergrundfarbe',
      backgroundColorTip:
        'Bestimmen Sie die Hintergrundfarbe, die der Chat haben soll.',
      fontFamily: 'Chat-Schriftart',
      fontFamilyTip: 'Bestimmen Sie die Schriftart, die der Chat haben soll.',
      fontSize: 'Chat-Schriftgröße',
      fontSizeTip: 'Bestimmen Sie die Schriftgröße, die der Chat haben soll.',
      messageArea: 'Nachrichtenbereich',
      enableAutoscroll: 'Autoscroll an',
      enableAutoscrollTip:
        'Aktivieren Sie das automatische Scrollen zu den neuesten Nachrichten',
      enableTextSelection: 'Text kopieren an',
      enableTextSelectionTip:
        'Aktivieren Sie das Auswählen und Kopieren des Textes der Nachrichten',
      assistantBubble: 'Buddy',
      userBubble: 'User',
      msgBubbleColorUser: 'Nachrichtenfarbe User',
      msgBubbleColorUserTip:
        'Bestimmen Sie die Farbe der Nachrichten, die Sie als User senden.',
      msgBubbleColorBuddy: 'Nachrichtenfarbe Buddy',
      msgBubbleColorBuddyTip:
        'Bestimmen Sie die Farbe der Nachrichten, die Buddy Ihnen sendet.',
      textColorUser: 'Textfarbe User',
      textColorUserTip:
        'Bestimmen Sie die Farbe des Texts der Nachrichten, die Sie als User senden.',
      textColorBuddy: 'Textfarbe Buddy',
      textColorBuddyTip:
        'Bestimmen Sie die Farbe des Texts der Nachrichten, die Buddy Ihnen sendet.',
      msgBubbleBorderUser: 'Rahmen Nachrichten User',
      msgBubbleBorderUserTip:
        'Bestimmen Sie, ob die Nachrichten, die Sie als User senden, einen Rahmen haben sollen.',
      msgBubbleBorderColorUser: 'Rahmenfarbe Nachrichten User',
      msgBubbleBorderColorUserTip:
        'Bestimmen Sie die Rahmenfarbe der Nachrichten, die Sie als User senden.',
      msgBubbleBorderBuddy: 'Rahmen Nachrichten Buddy',
      msgBubbleBorderBuddyTip:
        'Bestimmen Sie, ob die Nachrichten, die Buddy Ihnen sendet, einen Rahmen haben sollen.',
      msgBubbleBorderColorBuddy: 'Rahmenfarbe Nachrichten Buddy',
      msgBubbleBorderColorBuddyTip:
        'Bestimmen Sie die Rahmenfarbe der Nachrichten, die Buddy Ihnen sendet.',
      references: 'Quellen',
      referenceTextColor: 'Textfarbe Quellen',
      referenceTextColorTip:
        'Bestimmen Sie die Farbe des Texts der Quellen, die in den Nachrichten von Buddy referenziert werden',
      referenceTextColorHover: 'Textfarbe (Hover)',
      referenceTextColorHoverTip:
        'Bestimmen Sie die Farbe des Texts der Quellen, die in den Nachrichten von Buddy referenziert werden, wenn der Mauszeiger darüber schwebt.',
      buttonsReactions: 'Buttons & Reaktionen',
      primaryButtons: 'Chat-Buttons',
      buttonColor: 'Buttonfarbe',
      buttonTextColor: 'Textfarbe',
      buttonColorTip: 'Bestimmen Sie die Farbe der Buttons im Chat',
      buttonTextColorHover: 'Textfarbe (Hover)',
      buttonTextColorHoverTip:
        'Bestimmen Sie die Farbe des Texts der Buttons im Chat, wenn der Mauszeiger darüber schwebt.',
      reactionButtons: 'Reaktions-Buttons',
      reactionButtonColor: 'Button',
      reactionButtonTextColor: 'Text',
      reactionButtonColorTip:
        'Bestimmen Sie die Farbe der Reaktions-Buttons im Chat',
      reactionButtonColorHover: 'Button Hover',
      reactionButtonColorHoverTip:
        'Bestimmen Sie die Farbe der Reaktions-Buttons im Chat, wenn der Mauszeiger darüber schwebt.',
      reactionButtonTextColorHover: 'Text Hover',
      reactionButtonTextColorHoverTip:
        'Bestimmen Sie die Farbe des Texts der Reaktions-Buttons im Chat, wenn der Mauszeiger darüber schwebt.',
      reactionButtonColorActive: 'Button Aktiv',
      reactionButtonColorActiveTip:
        'Bestimmen Sie die Farbe der aktiven Reaktions-Buttons im Chat.',
      reactionButtonTextColorActive: 'Text Aktiv',
      reactionButtonTextColorActiveTip:
        'Bestimmen Sie die Farbe des Texts der aktiven Reaktions-Buttons im Chat.',
      inputField: 'Inputfeld',
      inputColor: 'Farbe Inputfeld',
      inputColorTip:
        'Bestimmen Sie die Farbe des Inputfelds zum Absenden von Nachrichten.',
      inputTextColor: 'Textfarbe Inputfeld',
      inputTextColorTip:
        'Bestimmen Sie die Farbe des Textes im Inputfeld zum Absenden von Nachrichten.',
      inputPlaceholderText: 'Text Input Platzhalter',
      inputPlaceholderTextTip:
        'Bestimmen Sie den Text des Platzhalters, der im Inputfeld zum Absenden von Nachrichten angezeigt wird.',
      footer: 'Fußbereich',
      footerText: 'Text Footer',
      footerTextTip:
        'Bestimmen Sie den Text, der im Footer unterhalb des Inputfelds angezeigt werden soll. Markdown wird unterstützt.',
      footerColor: 'Textfarbe Footer',
      footerColorTip:
        'Bestimmen Sie die Farbe des Footers unterhalb des Inputfelds.',
      footerTextDefault:
        'Buddy kann Fehler machen. Nutzung auf eigene Gefahr. [Innovative Gesundheit by ZTM](https://www.ztm.de/buddy).',
      knowledge: 'Wissen',
      knowledgeBases: 'Datenbanken',
      knowledgeBasesMessage: 'Bitte auswählen',
      knowledgeBasesTip:
        'Optional. Wählen Sie die Wissensdatenbanken aus, die Sie diesem Chat-Assistenten zuordnen möchten. Ohne Auswahl antwortet der Assistent nur auf Basis seines System-Prompts und des Gesprächsverlaufs – entfernen Sie in diesem Fall die Variable {knowledge} aus dem System-Prompt.',
      documentUpload: 'Dokumenten-Upload im Chat',
      documentUploadTip:
        'Erlaubt Chat-Nutzern, Dokumente in ihre Unterhaltung hochzuladen und für jede Frage auszuwählen, welche davon der Assistent verwenden darf. Uploads werden getrennt von Ihren Wissensdatenbanken gespeichert und einige Zeit nach dem Upload automatisch gelöscht.',
      documentUploadTitle: 'Dokumente in dieser Unterhaltung',
      chatUploadRetention: 'Hochgeladene Dokumente aufbewahren',
      chatUploadRetentionTip:
        'Wie lange ein Dokument nach dem Hochladen verfügbar bleibt. Jedes Dokument läuft für sich ab, gerechnet ab seinem Upload. Eine Änderung gilt für später begonnene Unterhaltungen; bereits laufende behalten die Aufbewahrungsdauer, mit der sie begonnen haben.',
      chatUploadRetentionNeedsHistory:
        'Eine längere Aufbewahrung setzt den Chatverlauf voraus, damit die Unterhaltung wieder geöffnet und die Dokumente erneut genutzt werden können. Sie aktivieren ihn unter „Assistent-Einstellungen“ — er benötigt außerdem gespeicherte Unterhaltungen und entweder Benutzeranmeldung oder App-Einladungen.',
      chatUploadRetentionDefault: 'Standard',
      chatUploadRetentionNotOffered:
        'Diese Installation bewahrt hochgeladene Dokumente für einen festen Zeitraum auf, daher gibt es hier nichts auszuwählen.',
      chatUploadRetentionDays: '{{days}} Tage',
      documentUploadAction: 'Dokument hochladen',
      documentUploadEmpty: 'Noch keine Dokumente hochgeladen.',
      documentUploadAnalysing: 'Wird analysiert…',
      documentUploadQueued: 'Wartet auf einen freien Analyse-Platz…',
      documentUploadFailed: 'Analyse fehlgeschlagen',
      documentUploadReady: 'Bereit',
      documentUploadRemove: 'Dokument entfernen',
      documentUploadTooLarge:
        'Diese Datei ist größer als das Upload-Limit von {{size}} MB.',
      documentUploadTooManyPages:
        'Dieses PDF hat {{pages}} Seiten. Es können maximal {{max}} Seiten analysiert werden.',
      documentUploadLimitReached:
        'Diese Unterhaltung enthält bereits die maximale Anzahl von {{limit}} Dokumenten.',
      documentUploadUnsupportedType: 'Dieser Dateityp wird nicht unterstützt.',
      documentUploadEmptyFile: 'Diese Datei ist leer.',
      documentUploadNoFile: 'Es wurde keine Datei hochgeladen.',
      documentUploadNoContent:
        'Aus diesem Dokument konnte kein Text gelesen werden, daher kann der Assistent es nicht verwenden.',
      documentUploadTransportFailed:
        'Die Datei konnte nicht hochgeladen werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      documentUploadHasErrors:
        'Einige Dokumente konnten nicht analysiert werden. Details in der Liste.',
      documentUploadSourceExpired: 'Quelle nicht mehr verfügbar',
      documentTools: 'Dokumente lesen',
      documentToolsTip:
        'Wie der Assistent ein einzelnes Dokument im Detail liest. „Relevante Ausschnitte“ holt die Passagen des Dokuments, die am besten zu einer Anfrage passen. „Navigation“ liest das Dokument in seiner ursprünglichen Reihenfolge – über Inhaltsverzeichnis, Abschnitt oder Seite – und kann lange Dokumente zusammenfassen. Vergleichen Sie beides mit einer Evaluation, bevor Sie umstellen. Setzt Tool-Nutzung und Reasoning voraus.',
      documentTools_legacy: 'Relevante Ausschnitte (Standard)',
      documentTools_navigation: 'Navigation nach Abschnitt und Seite (neu)',
      spreadsheetAnalysis: 'Excel-Auswertung',
      spreadsheetAnalysisTip:
        'Erlaubt dem Assistenten, exakte Werte – Summen, Mittelwerte, Anzahlen, Ranglisten – aus Excel-Arbeitsmappen (.xlsx, .xlsm) der Wissensdatenbanken und aus von Nutzern an eine Frage angehängten Arbeitsmappen zu berechnen. Er liest dafür die Arbeitsmappe selbst statt der Textausschnitte, die die Suche liefert. Setzt Tool-Nutzung und Reasoning voraus.',
      spreadsheetAnalysisStrategy: 'Auswertungsmethode',
      spreadsheetAnalysisStrategyTip:
        'Wie der Assistent mit einer Arbeitsmappe arbeitet. Leer lassen für die Voreinstellung dieser Installation; eine explizite Auswahl erlaubt den Vergleich der Methoden in einer Evaluation.',
      spreadsheetAnalysisStrategyDefault: 'Voreinstellung dieser Installation',
      spreadsheetAnalysisStrategy_sql: 'SQL-Abfragen',
      webSearch: 'Websuche',
      webSearchTip:
        'Aktivieren Sie diese Option, damit der Assistent bei Fragen, die nicht durch die Wissensdatenbanken abgedeckt sind, eine Live-Websuche durchführt. Dabei werden keine Webseiten vollständig durchsucht – stattdessen ruft der Assistent die Vorschautexte (Snippets) ab, die die eingestellte Suchmaschine (Standard: Brave) für die jeweilige Anfrage aus den erlaubten Domains zurückgibt.',
      webSearchProvider: 'Suchanbieter',
      webSearchProviderTip:
        'Automatisch nutzt die Brave-Search-API, sofern für diese Installation ein API-Schlüssel hinterlegt ist, sonst das schlüssellose ddgs-Backend. Brave-Search-API nutzt immer die API und liefert ohne hinterlegten Schlüssel keine Ergebnisse.',
      webSearchProviderAuto: 'Automatisch (Brave-API, falls konfiguriert)',
      webSearchProviderBraveApi: 'Brave-Search-API',
      webSearchProviderDdgs: 'ddgs (ohne Schlüssel)',
      webSearchBackend: 'Backend',
      webSearchBackendTip:
        'Suchmaschinen, die das schlüssellose ddgs-Backend abfragt. Ohne Wirkung, wenn die Brave-Search-API genutzt wird.',
      webSearchAllowedSites: 'Websuche Erlaubte Domains',
      webSearchAllowedSitesTip:
        'Geben Sie eine durch Kommas getrennte Liste von Domains an, die der Assistent bei der Websuche verwenden darf. Lassen Sie dieses Feld leer, um alle Domains zuzulassen.',
      WebSearchPleaseSelectAtLeastOneBackend:
        'Bitte wählen Sie mindestens einen Websuche-Backend-Anbieter aus.',
      pubmedSearch: 'PubMed-Suche',
      pubmedSearchTip:
        'Aktivieren Sie diese Option, wenn der Assistent die PubMed-Suchfunktionen nutzen soll, um Fragen zu beantworten, die nicht durch die Wissensdatenbanken abgedeckt sind.',
      pubmedEmail: 'PubMed E-Mail',
      pubmedEmailTip:
        'Geben Sie Ihre E-Mail-Adresse ein, die für PubMed API-Anfragen verwendet wird. Dies hilft NCBI, den Datenverkehr zu überwachen und Missbrauch zu verhindern.',
      pubmedEmailInitialValue: 'email@example.com',
      pubmedSearchMaxResults: 'Maximale PubMed-Ergebnisse',
      pubmedSearchMaxResultsTip:
        'Legen Sie die maximale Anzahl der PubMed-Suchergebnisse fest, die der Assistent für jede Anfrage abrufen soll. Ein höherer Wert kann umfassendere Antworten liefern, aber auch die Antwortzeit verlängern.',
      pubmedSearchMaxResultsInitialValue: 5,
      pubmedQueryBuilder: 'PubMed-Abfrage-Generator',
      pubmedQueryBuilderTip:
        'Ihre Aufforderungen oder Anweisungen für das LLM zur Generierung einer präzisen PubMed-Suchabfrage basierend auf der Nutzerfrage und dem Chatverlauf.',
      pubmedQueryBuilderInitialValue: `Deine Aufgabe ist es, eine präzise PubMed-Suchabfrage zu generieren, die auf der Nutzerfrage und dem Chatverlauf basiert.`,
      system: 'System',
      systemInitialValue: `Du bist ein intelligenter Assistent. Bitte fasse den Inhalt der Wissensdatenbank zusammen, um die Frage zu beantworten. Bitte listen Sie die Daten in der Wissensdatenbank auf und beantworten Sie die Frage im Detail. Wenn alle Inhalte der Wissensdatenbank für die Frage irrelevant sind, muss Ihre Antwort den Satz „Die gesuchte Antwort ist nicht in der Wissensdatenbank zu finden!“ enthalten. Die Antworten müssen den Chatverlauf berücksichtigen.
      Heute ist der {now}.
      Hier ist die Wissensdatenbank:
      {knowledge}
      Das darüber ist die Wissensdatenbank.`,
      systemMessage: 'Bitte eingeben!',
      systemTip:
        'Ihre Aufforderungen oder Anweisungen für das LLM, einschließlich, aber nicht beschränkt auf seine Rolle, die gewünschte Länge, den Ton und die Sprache seiner Antworten.',
      enterFullscreen: 'Im Vollbild bearbeiten',
      exitFullscreen: 'Vollbild verlassen (Esc)',
      promptRefineQuestion: 'Suchprompt',
      promptRefineQuestionTip:
        'Ihre Aufforderungen oder Anweisungen für das LLM bezüglich der Verfeinerung der Frage und Berücksichtigung des Chatverlaufs.',
      promptRefineQuestionInitialValue: `Role: Ein hilfreicher Buddy

Aufgabe und Schritte:  
1. Formuliere die vollständige Nutzerfrage, die logisch auf das bisherige Gespräch folgt.  
2. Wenn die Nutzerfrage relative Zeitangaben enthält (z. B. „gestern“, „nächste Woche“), wandle diese in absolute Daten um, basierend auf dem aktuellen Datum {today}. Beispiel: „gestern“ → {yesterday}.  
3. Achte darauf, dass medizinische Abkürzungen (z. B. „MS“) automatisch einmal ausgeschrieben werden, mit der Abkürzung in Klammern: „Multiple Sklerose (MS)“.  

Anforderungen & Einschränkungen:  
- Der erzeugte Text MUSS in derselben Sprache sein wie die ursprüngliche Nutzerfrage (standardmäßig Deutsch).  
- Wenn die letzte Nutzerfrage bereits vollständig und eindeutig ist, tue nichts und gib die ursprüngliche Frage zurück.  
- Erzeuge KEINEN zusätzlichen Text außer der verfeinerten Frage.  

######################  
-Beispiele-  
######################  

# Beispiel 1  
## Gespräch  
USER: Welche Symptome hat MS?  
ASSISTANT: Müdigkeit und Sehstörungen sind häufig.  
USER: Und bei älteren Patienten?  
###############  
Output: Welche Symptome treten bei älteren Patienten mit Multiple Sklerose (MS) auf?  

------------  
# Beispiel 2  
## Gespräch  
USER: Welche Nebenwirkungen hat Ibuprofen?  
ASSISTANT: Häufig sind Magenbeschwerden.  
USER: Und bei Langzeiteinnahme?  
###############  
Output: Welche Nebenwirkungen treten bei Langzeiteinnahme von Ibuprofen auf?  

------------  
# Beispiel 3  
## Gespräch  
USER: Was ist Bluthochdruck?  
ASSISTANT: Eine Erkrankung, bei der der Blutdruck dauerhaft erhöht ist.  
USER: Und welche Werte gelten dafür bei Erwachsenen?  
###############  
Output: Welche Blutdruckwerte gelten bei Erwachsenen als Bluthochdruck?  

------------  
# Beispiel 4 (mit Datum)  
## Gespräch  
USER: Welche Vorsorgeuntersuchungen sollte man ab 50 machen?  
ASSISTANT: Darmspiegelung wird empfohlen.  
USER: Und was, wenn ich das letzte Mal vor zwei Jahren dort war?  
###############  
Output: Welche Vorsorgeuntersuchungen werden für eine Person empfohlen, die ihre letzte Darmspiegelung am {two_years_ago} hatte und nun 50 Jahre alt ist?  

######################  

# Reale Daten  
## Gespräch  
{conv}  
##############
      `,
      promptLinkQuotes: 'Quellenannotation',
      promptLinkQuotesTip:
        'Ihre Aufforderungen oder Anweisungen für das LLM bezüglich der Verknüpfung von Quellen in den Antworten (wie und wo wird zitiert, welche Arten von Quellen müssen angegeben werden).',
      promptLinkQuotesInitialValue: `Deine Aufgabe ist es, Aussagen im Antworttext ausschließlich dann mit Chunk-Zitaten zu versehen, wenn diese Aussagen direkt und inhaltlich belastbar durch die bereitgestellten Chunks gestützt werden.

Ziel:
Jede inhaltlich relevante Aussage, die wesentlich auf Informationen aus den Chunks beruht, MUSS ein Zitat erhalten.
Es dürfen dabei keinerlei fehlerhafte, ungenaue oder spekulative Zitate entstehen.

Arbeite extrem sorgfältig und prüfe akribisch jede einzelne Aussage.
Du darfst keine Fehler machen.

Regeln:
- Jede inhaltlich relevante Aussage, die wesentlich aus den bereitgestellten Chunks stammt, MUSS zitiert werden.
- Wenn eine solche Aussage nicht sicher zitierbar ist, darf sie nicht als durch die Chunks gestützte Behauptung erscheinen.
- Zitiere jede Aussage, die ohne die Chunks nicht in dieser Form behauptet werden könnte.
- Zitiere auch dann, wenn die Aussage im Antworttext paraphrasiert ist, solange der Chunk die Aussage inhaltlich klar trägt.
- Berücksichtige dabei auch Synonyme, umformulierte Inhalte und semantisch gleichwertige Aussagen.
- Ein Zitat darf nur gesetzt werden, wenn der Chunk die Aussage direkt, eindeutig und wesentlich stützt.
- Wenn du dir nicht sicher bist, ob ein Chunk die Aussage wirklich trägt, darfst du kein Zitat setzen.
- Wenn mehrere Chunks passen, wähle den präzisesten und relevantesten Chunk.
- Verwende ausschließlich die Indexnummern der Chunks, beginnend bei 0.
- Füge keine zusätzlichen Erklärungen oder Kommentare hinzu.
- Antworte ausschließlich mit dem überarbeiteten Text inklusive der Zitate.
- Wenn mehrere aufeinanderfolgende Textstellen dasselbe Zitat benötigen, füge das Zitat nur einmal am Ende der letzten passenden Textstelle ein.
- Setze niemals ein Zitat nur deshalb, weil das Thema allgemein ähnlich ist.
- Setze niemals ein Zitat für allgemeines Weltwissen, stilistische Verbindungswörter oder rein logische Übergänge, sofern diese nicht auf Chunk-Inhalten beruhen.
- Wenn eine Aussage teilweise gestützt und teilweise nicht gestützt ist, zitiere sie nicht unsauber. In diesem Fall darf nur der tatsächlich gestützte Teil ein Zitat erhalten.

Wichtige Priorität:
Fehlende Zitate bei klar gestützten Aussagen sind ein Fehler.
Falsche oder zu schwache Zitate sind ebenfalls ein Fehler.
Zitiere daher streng, präzise und vollständig.

Beispiele:
- Wenn ein Chunk sagt, dass AOSD häufig Knie und Handgelenke betrifft, dann darf eine Aussage wie
  "Typischerweise sind vor allem Knie und Handgelenke betroffen ##3$$"
  zitiert werden.
- Wenn ein Chunk nur allgemein Arthritis erwähnt, aber keine betroffenen Gelenke nennt, dann darf die Aussage
  "Typischerweise sind Knie und Handgelenke betroffen"
  nicht mit diesem Chunk zitiert werden.
- Wenn der Antworttext eine Formulierung wie "entzündete Gelenke" verwendet und der Chunk von "Arthritis" spricht, darf zitiert werden, sofern die Aussage inhaltlich gleichwertig ist.

Ausgabeformat:
- Nur der final überarbeitete Text mit Zitaten.
- Keine Metakommentare.`,
      promptSuggestedQuestions: 'Folgefragen Prompt',
      promptSuggestedQuestionsTip:
        'Ihre Aufforderungen oder Anweisungen für das LLM bezüglich der Generierung von Folgefragen',
      promptSuggestedQuestionsInitialValue: `Zielsetzung: Generierung von Fragen, die der Nutzer stellen könnte und die an den bisherigen Chatverlauf zwischen Nutzer und Chatbot anschließen, um den Nutzer durch das Gespräch zu führen. 
Instruktionen:
- Nenne 2 weitere Fragen aus der Sicht des Nutzers, die er nach dem bisherigen Gesprächsverlauf stellen könnte.
- Keine Frage zu formulieren ist KEINE OPTION.
- Verwende keine Klammern oder dergleichen. Die Fragen sollen NUR Text beinhalten.
- Es ist wichtig, dass du Fragen definierst, die den Gesprächsverlauf nicht zu sehr in eine Richtung lenkt sondern auch variiert und den Gesprächsverlauf auch wieder auf medizinische und gesundheitliche Themen lenkt.
- Gehe nicht zu tief in ein einzelnes Detail ab, wenn der Gesprächsverlauf schon oft in eine Richtung ging, variiere auch die Fragen.
- NICHT übersetzen, sondern die Sprache der ursprünglichen Frage verwenden.
- Generiere keine Fragen, die im bisherigen Gesprächsverlauf bereits beantwortet wurden.
- Nutze zur Generierung der Fragen das folgende Wissen, sodass vor allem Fragen gestellt werden, die durch das Wissen beantwortet werden können. Falls kein Wissen vorliegt, generiere trotzdem die Fragen.
      
      Wissen: 

      {knowledge}

      Ende des Wissens

### Beispiel:
Chatverlauf:
    User: Was sind die häufigsten Symptome von Diabetes?
    Assistant: Häufige Symptome von Diabetes sind starker Durst, häufiges Wasserlassen, Müdigkeit, Gewichtsverlust, Heißhunger, verschwommenes Sehen, schlecht heilende Wunden, Infektionen und Kribbeln in Händen oder Füßen.
Fragenvorschläge:
1. Wie wird Diabetes diagnostiziert?
2. Welche Behandlungsmöglichkeiten gibt es für den Umgang mit Diabetes?`,
      promptGlossary: 'Glossar',
      promptGlossaryTip:
        'Hinterlegtes Glossar für Fachbegriffe, die im Chatverlauf oder in der Quellensuche & Linking verwendet werden.',
      promptGlossaryInitialValue: `ZTM = Zentrum für Telemedizin
MS = Multiple Sklerose
HI = Herzinsuffizienz
TTS = Text to Speech
STT = Speech to Text
LLM = Large Language Model`,
      topN: 'Anzahl Treffer',
      topNTip: `Nicht alle Chunks mit einem Ähnlichkeitswert über der 'Ähnlichkeitsschwelle' werden an den LLM gesendet. Dieser wählt 'Top N' Chunks aus den abgerufenen Chunks aus.`,
      variable: 'Variable',
      variableTip: `Variablen können bei der Entwicklung flexiblerer Strategien helfen, insbesondere wenn Sie unsere APIs zur Verwaltung von Chat-Assistenten verwenden. Diese Variablen werden vom „System“ als Teil der Eingabeaufforderungen für das LLM verwendet. Die Variable {knowledge} ist eine reservierte Spezialvariable, die Ihre ausgewählte(n) Wissensbasis(n) repräsentiert, und alle Variablen sollten in geschweifte Klammern {} eingeschlossen werden.`,
      add: 'Hinzufügen',
      key: 'Schlüssel',
      optional: 'Optional',
      operation: 'Betrieb',
      model: 'Modell',
      modelTip: 'Chat-Modell in großer Sprache',
      modelMessage: 'Bitte auswählen!',
      subtaskModel: 'Subtask-Modell',
      subtaskModelTip:
        'Chat-Modell für Subtasks wie Fragen-Refinement, Schlüsselwort-Extraktion, Quellenannotation, Folgefragen und Gesprächstitel. Wenn nicht gesetzt, wird das Hauptmodell verwendet. Individuelle Modelle aus dem Bereich „Erweitert“ darunter haben Vorrang.',
      subtaskModelPlaceholder: 'Standard',
      agenticSubtaskModelTip:
        'Agentisches Routing, Tool-Auswahl und die finale Antwort verwenden das Hauptmodell. Unten werden nur passende Hilfsaufgaben angezeigt.',
      subtaskModelsAdvanced: 'Erweitert · Modelle pro Subtask',
      subtaskModelsAdvancedTip:
        'Überschreibe das Modell für jeden Subtask einzeln. Die Felder zeigen das allgemeine Subtask-Modell als Standard; ein Wert wird erst gespeichert, wenn du ihn änderst. Vorrang: individuelles Modell > Subtask-Modell > Hauptmodell.',
      subtaskRefinement: 'Fragen-Refinement',
      subtaskRetrievalTranslation: 'Retrieval-Übersetzung',
      subtaskKeywordExtraction: 'Schlüsselwort-Extraktion',
      subtaskSourceLinking: 'Quellenverlinkung',
      subtaskFollowupKeywords: 'Folgefragen – Schlüsselwörter',
      subtaskFollowupGeneration: 'Folgefragen – Generierung',
      subtaskConversationTitle: 'Gesprächstitel',
      subtaskDocumentSummary: 'Dokument-Zusammenfassung',
      toolsEnabled: 'Tool-Nutzung aktivieren',
      toolsEnabledTip:
        'Aktiviert den agentischen Tool-Loop (z. B. Wissensdatenbank-Suche) für diesen Chatbot. Nur wenn dieser Schalter und „Reasoning aktivieren“ beide eingeschaltet sind, laufen Anfragen über den agentischen Pfad statt über die klassische Antwort-Pipeline.',
      reasoningEnabled: 'Reasoning aktivieren',
      reasoningEnabledTip:
        'Behandelt das ausgewählte Modell als Reasoning-Modell. Nur wenn dieser Schalter und „Tool-Nutzung aktivieren“ beide eingeschaltet sind, laufen Anfragen über den agentischen Pfad statt über die klassische Antwort-Pipeline.',
      mcpTools: 'MCP-Werkzeuge',
      mcpToolsTip:
        'Wählen Sie, welche MCP-Werkzeuge dieser Chatbot nutzen darf. Erfordert „Tool-Nutzung aktivieren“ und „Reasoning aktivieren“. MCP-Server werden unter Einstellungen → MCP-Werkzeuge konfiguriert.',
      mcpToolsPlaceholder: 'MCP-Werkzeuge auswählen…',
      consultedBuddies: 'Konsultierte Buddies',
      consultedBuddiesTip:
        'Andere Chatbots, die dieser Chatbot um eine Antwort bitten darf. Er entscheidet selbst, wann er einen fragt, übernimmt dessen Quellen und zitiert sie. Angeboten werden die Chatbots Ihrer Teams und frei verfügbare Chatbots, die per Freigabelink hinzugefügt werden. Erfordert „Tool-Nutzung aktivieren“ und „Reasoning aktivieren“.',
      consultedBuddiesPlaceholder: 'Chatbots auswählen…',
      consultedBuddyLinkPlaceholder: 'Freigabelink oder Chatbot-ID einfügen',
      consultedBuddyAdd: 'Hinzufügen',
      consultedBuddyInvalidLink:
        'Das ist kein Freigabelink und keine Chatbot-ID.',
      consultedBuddyNotConsultable:
        'Dieser Chatbot kann nicht konsultiert werden: Er existiert hier nicht, oder er verlangt eine Anmeldung und gehört zu einem anderen Team.',
      consultedBuddyUnavailable: 'nicht verfügbar',
      consultedBuddyLookupFailed:
        'Dieser Chatbot konnte nicht geprüft werden. Bitte erneut versuchen.',
      freedom: 'Freiheit',
      improvise: 'Improvisieren',
      precise: 'Präzise',
      balance: 'Gleichgewicht',
      freedomTip: `Setzen Sie den Freiheitsgrad auf „Präzise“, um die Antwort des LLM streng auf die von Ihnen ausgewählte(n) Wissensbasis(n) zu beschränken. Wählen Sie „Improvisieren“, um dem LLM eine größere Freiheit bei seinen Antworten zu geben, was zu Halluzinationen führen kann. Balance' ist ein mittleres Niveau; wählen Sie 'Balance' für ausgewogenere Antworten.`,
      temperature: 'Temperatur',
      temperatureMessage: 'Temperatur ist erforderlich',
      temperatureTip: `Dieser Parameter steuert die Zufälligkeit der Vorhersagen des Modells. Eine niedrigere Temperatur führt zu konservativeren Antworten, während eine höhere Temperatur zu kreativeren und vielfältigeren Antworten führt.`,
      termsOfUseDefaultTitle: 'KI im Einsatz',
      termsOfUseDefaultText: `Der Buddy ist eine künstliche Intelligenz mit der du chatten kannst und wurde entwickelt, um die Recherche von Gesundheitsthemen zu erleichten.\n\nBitte beachte dabei folgendes:\n• Dein Chatverlauf wird gespeichert und kann anonymisiert ausgewertet werden.\n• Dein Feedback (\uD83D\uDC4D/\uD83D\uDC4E) hilft, ihn zu verbessern.`,
      termsOfUseFooter: 'Innovative Gesundheit by',
      termsOfUseBtnConfirm: 'Einverstanden',
      topP: 'Top P',
      topPMessage: 'Top P ist erforderlich',
      topPTip:
        'Dieser Parameter wird auch als „Nukleus-Sampling“ bezeichnet und legt einen Schwellenwert für die Auswahl einer kleineren Menge der wahrscheinlichsten Wörter für die Stichprobe fest, wobei die weniger wahrscheinlichen Wörter abgeschnitten werden.',
      presencePenalty: 'Presence Penalty',
      presencePenaltyMessage: 'Es ist eine Presence Penalty erforderlich',
      presencePenaltyTip:
        'Dies hält das Modell davon ab, dieselben Informationen zu wiederholen, indem Wörter bestraft werden, die bereits im Gespräch aufgetaucht sind.',
      frequencyPenalty: 'Frequency Penalty',
      frequencyPenaltyMessage: 'Frequency Penalty ist erforderlich',
      frequencyPenaltyTip:
        'Ähnlich wie bei der "Presence Penalty" verringert dies die Tendenz des Modells, dieselben Wörter häufig zu wiederholen.',
      maxTokens: 'Max. Token',
      maxTokensMessage: 'Es sind maximale Token erforderlich',
      maxTokensTip: `Legt die maximale Länge der Ausgabe des Modells fest, gemessen an der Anzahl der Token (Wörter oder Wortteile). Der Standardwert ist 512. Wenn Sie diese Option deaktivieren, heben Sie die maximale Token-Begrenzung auf, so dass das Modell die Anzahl der Token in seinen Antworten selbst bestimmen kann.`,
      maxTokensInvalidMessage:
        'Bitte geben Sie eine gültige Zahl für Max Tokens ein.',
      maxTokensMinMessage:
        'Die maximale Anzahl an Token darf nicht kleiner als 0 sein.',
      quote: 'Quelle anzeigen',
      quoteTip: 'Ob der Originaltext als Referenz angezeigt werden soll.',
      useLLMForQuotes: 'LLM für Zitate verwenden',
      useLLMForQuotesTip:
        'Wenn diese Option aktiviert ist, wird das LLM verwendet, um die Zitate zu identifizieren und anzuzeigen. Andernfalls wird ein statistisches Verfahren angewendet, welches u.U. weniger exakt ist.',
      showFootnoteMarkers: 'Fußnotenmarkierungen anzeigen',
      showFootnoteMarkersTip:
        'Zeigt oder verbirgt die hochgestellten Ziffern im Text, die auf Fußnoten verweisen.',
      showImagesTitle: 'Bildanzeige in Quellen',
      showImagesTitleTip:
        'Ob Bilder im Quellen-Overlay angezeigt werden sollen.',
      showReferenceDate: 'Quellendatum ("Stand") anzeigen',
      showReferenceDateTip:
        'Zeigt in der Referenzliste unter jeder Quelle die Zeile "Stand: <Datum>" an – das Erstellungsdatum des referenzierten Dokuments.',
      promptIcon: 'Debug-Modus',
      promptIconTip:
        'Gibt den Prompt inklusive Chunks in Entwicklerkonsole aus.',
      promptViewSections: 'Abschnitte',
      promptViewRaw: 'Rohtext',
      promptSectionLines_one: '{{count}} Zeile',
      promptSectionLines_other: '{{count}} Zeilen',
      selfRag: 'Selbst-RAG',
      selfRagTip:
        'Bitte beachten Sie: https://huggingface.co/papers/2310.11511',
      overview: 'Chat-ID',
      pv: 'Anzahl der Nachrichten',
      uv: 'Aktive Benutzernummer',
      speed: 'Geschwindigkeit der Token-Ausgabe',
      tokens: 'Verbrauchen Sie die Token-Nummer',
      round: 'Sitzungsinteraktionsnummer',
      thumbUp: 'Kundenzufriedenheit',
      preview: 'Vorschau',
      embedded: 'Eingebettet',
      serviceApiEndpoint: 'Service-API-Endpunkt',
      apiKey: 'API-SCHLÜSSEL',
      apiReference: 'API-Dokumente',
      dateRange: 'Datumsbereich:',
      backendServiceApi: 'API-Server',
      createNewKey: 'Neuen Schlüssel erstellen',
      created: 'Erstellt',
      action: 'Aktion',
      embedModalTitle: 'Teilen',
      comingSoon: 'Kommt bald',
      embedTitle: 'Allgemeine Einbettung',
      embedDescription: 'Iframe für Ihre Website',
      embedTitleWithStartQuestion: 'Einbettung mit Anfangsfrage',
      embedTitleWithUserAuth: 'Einbettung mit Benutzerauthentifizierung',
      embedDescriptionWithStartQuestion:
        'Iframe und Script für Ihre Website.\nGeben Sie eine Anfangsfrage an, mit der der Chat automatisch starten soll.',
      embedDescriptionWithUserAuth:
        'Iframe und Skript für Ihre Webseite mit Benutzerauthentifizierung.',
      embedStartQuestionInput: 'Ihre Anfangsfrage',
      embedUserAuthNote:
        'Benutzerauthentifizierung erlaubt es, den Buddy in Ihre Anwendung einzubinden, aber nur für bestimmte Benutzer oder Benutzergruppen (bspw. Premium-Nutzer) verfügbar zu machen.\n\nIst dieses Feature aktiviert, muss Ihre Anwendung den Zugriff auf den Buddy autorisieren. Nur berechtigte Benutzer, die über einen gültigen Token verfügen, können dann auf den eingebetteten Buddy zugreifen.\n\nDie Authentifizierung erfolgt über JWT-Token, die von Ihrer Anwendung ausgestellt werden.\n\nDieses Feature muss in den Einstellungen des Buddys aktiviert und ein Schlüsselpaar (Public/Private) generiert werden. Dies können Sie bequem in den Einstellungen des Buddys unter `Assistent > Sonstiges > Zugriff einschränken > Benutzerauthentifizierung` erledigen.\n\nMit dem privaten Schlüssel signieren Sie die Tokens in Ihrer Anwendung, während der öffentliche Schlüssel im Buddy hinterlegt wird, um die Tokens zu verifizieren.\n\n**Token übergeben:** Die Iframe-URL muss `auth_strategy=user_token` enthalten. Damit wird dem Buddy signalisiert, dass er auf den Token per postMessage warten soll, bevor er startet — ohne diesen Parameter könnte der Buddy einen zwischengespeicherten Session-Token verwenden, bevor Ihr Token eintrifft. Sobald der Chat bereit ist, sendet er eine `chat_loaded`-Nachricht. Ihre Seite hört auf dieses Ereignis und antwortet, indem sie den Token per `postMessage` mit `type: \"set_user_token\"` überträgt.\n\nBei Fragen zur Implementierung der Benutzerauthentifizierung können Sie sich gerne an unser Support-Team wenden.',
      embedDescriptionWithUserAuthRenewal: 'Skript für Token-Erneuerung',
      embedUserAuthRenewalNote:
        'Aus Sicherheitsgründen haben JWT-Token in der Regel eine begrenzte Lebensdauer. Um eine nahtlose Benutzererfahrung zu gewährleisten, sollten Sie einen Mechanismus implementieren, der abgelaufene Tokens erneuert, ohne dass der Benutzer den Chat neu laden muss.\n\nDas bereitgestellte Beispiel-Skript zeigt, wie der initiale Token beim `chat_loaded`-Event übertragen und anschließend regelmäßig erneuert wird — jeweils per `postMessage` mit `type: \"set_user_token\"`. Passen Sie das Erneuerungsintervall entsprechend Ihren Sicherheitsanforderungen an.',
      partialTitle: 'Teilweise Einbettung',
      extensionTitle: 'Chrome-Erweiterung',
      tokenError: 'Bitte erstellen Sie zuerst einen API-Schlüssel.',
      searching: 'Suche...',
      parsing: 'Parsing',
      uploading: 'Hochladen',
      uploadFailed: 'Der Upload ist fehlgeschlagen',
      regenerate: 'Regenerieren',
      read: 'Inhalt lesen',
      tts: 'Vorlesefunktion',
      ttsTip:
        'Stellen Sie sicher, dass Sie auf der Seite „Einstellungen“ ein TTS-Modell auswählen, bevor Sie diesen Schalter aktivieren, um Text als Audio abzuspielen.',
      ttsVoice: 'Stimme',
      ttsVoiceTip: 'Wählen Sie eine Stimme für die Vorlesefunktion.',
      stt: 'Spracherkennung',
      sttTip:
        'Stellen Sie sicher, dass Sie auf der Seite „Einstellungen” ein Speech-to-Text-Modell auswählen, bevor Sie diesen Schalter aktivieren, um Text über Mikrofon einzusprechen.',
      diarization: 'Sprecheridentifikation',
      diarizationTip:
        'Aktiviert den Diarisierungs-API-Endpunkt für diesen Chatbot. Erfordert ein Diarisierungsmodell in den Systemmodelleinstellungen.',
      diarizationCorrection: 'Diarisierungs-LLM-Korrektur',
      diarizationCorrectionTip:
        'Nach der Diarisierung wird das Ergebnis durch das LLM des Dialogs geleitet, um Sprecherzuordnung und Transkriptionsfehler zu korrigieren.',
      diarizationCorrectionPrompt: 'Korrektur-Prompt',
      diarizationCorrectionPromptTip:
        'Prompt, der zusammen mit dem Diarisierungs-JSON an das LLM gesendet wird. Das LLM muss gültiges JSON im selben Format zurückgeben.',
      callMode: 'Anrufmodus',
      callModeTip:
        'Im Anrufmodus können Sie mit dem Chatbot ein Gespräch wie bei einem Telefonanruf führen. Ein STT und TTS-Modell muss in den Einstellungen aktiviert sein.',
      callModeBackgroundColor: 'Hintergrundfarbe Anrufmodus',
      callModeBackgroundColorTip:
        'Bestimmen Sie die Hintergrundfarbe, die im Anrufmodus angezeigt werden.',
      callModeTextColor: 'Textfarbe Anrufmodus',
      callModeTextColorTip:
        'Bestimmen Sie die Farbe des ausgegebenen Textes im Anrufmodus.',
      callModeTextBlurColor: 'Text-Leucht-Effektfarbe Anrufmodus',
      callModeTextBlurColorTip:
        'Bestimmen Sie die Farbe des Leucht-Effekts des ausgegebenen Textes im Anrufmodus.',
      callModeButtonsColor: 'Buttonfarbe Anrufmodus',
      callModeButtonsColorTip:
        'Bestimmen Sie die Farbe der Buttons im Anrufmodus',
      recording: 'Aufnehmen…',
      startRecording: 'Aufnahme starten',
      cancelRecording: 'Aufnahme abbrechen',
      submitRecording: 'Aufnahme in Text umwandeln',
      startCallMode: 'Anrufmodus starten',
      stopCallMode: 'Anrufmodus beenden',
      listen: 'Anhören',
      stop: 'Stopp',
      relatedQuestion: 'Verwandte Frage',
      answerTitle: 'Buddy',
      multiTurn: 'Optimierung der Nutzeranfrage',
      multiTurnTip:
        'Dadurch werden Benutzerabfragen mithilfe des Kontexts für die Inhaltssuche optimiert. Die Anfrage an den Buddy wird dadurch konkretisiert.',
      howUseId: 'Wie verwende ich die Chat-ID?',
      description: 'Beschreibung',
      messageReferencesLabel: 'Quellen',
      urlDateLabel: 'Stand:',
    },
    setting: {
      profile: 'Profil',
      profileDescription:
        'Aktualisieren Sie hier Ihr Foto und Ihre persönlichen Daten.',
      maxTokens: 'Maximale Token',
      maxTokensMessage: 'Max. Tokens sind erforderlich',
      maxTokensTip: `This sets the maximum length of the model's output, measured in the number of tokens (words or pieces of words). Defaults to 512. If disabled, you lift the maximum token limit, allowing the model to determine the number of tokens in its responses.`,
      maxTokensInvalidMessage:
        'Bitte geben Sie eine gültige Zahl für Max Tokens ein.',
      maxTokensMinMessage:
        'Die maximale Anzahl an Token darf nicht kleiner als 0 sein.',
      password: 'Passwort',
      passwordDescription:
        'Bitte geben Sie Ihr aktuelles Passwort ein, um Ihr Passwort zu ändern.',
      model: 'Modellanbieter',
      modelDescription:
        'Legen Sie hier die Modellparameter und den API-SCHLÜSSEL fest.',
      team: 'Team',
      system: 'System',
      logout: 'Abmelden',
      api: 'API',
      username: 'Benutzername',
      usernameMessage: 'Bitte geben Sie Ihren Benutzernamen ein!',
      photo: 'Dein Foto',
      photoDescription: 'Dies wird in Ihrem Profil angezeigt.',
      colorSchema: 'Farbschema',
      colorSchemaMessage: 'Bitte wählen Sie Ihr Farbschema aus!',
      colorSchemaPlaceholder: 'Wählen Sie Ihr Farbschema',
      bright: 'Hell',
      dark: 'Dunkel',
      timezone: 'Zeitzone',
      timezoneMessage: 'Bitte geben Sie Ihre Zeitzone ein!',
      timezonePlaceholder: 'Wählen Sie Ihre Zeitzone aus',
      email: 'E-Mail-Adresse',
      emailDescription:
        'Nach der Registrierung kann die E-Mail-Adresse nicht mehr geändert werden.',
      currentPassword: 'Aktuelles Passwort',
      currentPasswordMessage: 'Bitte geben Sie Ihr Passwort ein!',
      newPassword: 'Neues Passwort',
      newPasswordMessage: 'Bitte geben Sie Ihr Passwort ein!',
      newPasswordDescription:
        'Ihr neues Passwort muss mehr als 12 Zeichen lang sein.',
      passwordTooWeak:
        'Das Passwort ist zu schwach. Bitte wählen Sie ein stärkeres Passwort.',
      confirmPassword: 'Bestätigen Sie das neue Passwort',
      confirmPasswordMessage: 'Bitte bestätigen Sie Ihr Passwort!',
      confirmPasswordNonMatchMessage:
        'Das von Ihnen eingegebene neue Passwort stimmt nicht überein!',
      cancel: 'Abbrechen',
      addedModels: 'Modelle hinzugefügt',
      modelsToBeAdded: 'Modelle, die hinzugefügt werden können',
      addTheModel: 'Modell hinzufügen',
      apiKey: 'API-Schlüssel',
      apiKeyMessage:
        'Bitte geben Sie den API-Schlüssel ein (ignorieren Sie diesen bei lokal bereitgestellten Modellen).',
      apiKeyTip:
        'Den API-Schlüssel erhalten Sie durch die Registrierung des entsprechenden LLM-Anbieters.',
      showMoreModels: 'Modelle anzeigen',
      baseUrl: 'Basis-URL',
      baseUrlTip:
        'Wenn Ihr API-Schlüssel von OpenAI stammt, ignorieren Sie ihn einfach. Alle anderen Zwischenanbieter geben diese Basis-URL mit dem API-Schlüssel an.',
      modify: 'Ändern',
      systemModelSettings: 'Systemmodelleinstellungen',
      chatModel: 'Chat-Modell',
      chatModelTip:
        'Der Standard-Chat-LLM wird von allen neu erstellten Wissensdatenbanken verwendet.',
      embeddingModel: 'Einbettungsmodell',
      embeddingModelTip:
        'Das standardmäßige Einbettungsmodell, das alle neu erstellten Wissensdatenbanken verwenden.',
      img2txtModel: 'Img2txt-Modell',
      img2txtModelTip:
        'Das Standardmodell mit mehreren Modulen, das von allen neu erstellten Wissensdatenbanken verwendet wird. Es kann ein Bild oder Video beschreiben.',
      sequence2txtModel: 'Sequence2txt-Modell',
      sequence2txtModelTip:
        'Das Standard-ASR-Modell, das alle neu erstellten Wissensdatenbanken verwenden. Verwenden Sie dieses Modell, um Stimmen in entsprechenden Text zu übersetzen.',
      rerankModel: 'Reranker',
      rerankModelTip: `Das Standard-Rerank-Modell wird verwendet, um die von den Fragen der Benutzer abgerufenen Chunks zu ranken.`,
      speech2txtModel: 'Speech2txt-Modell',
      speech2txtModelTip:
        'Das Standard-Speech2txt- bzw. ASR-Modell, das Spracheingabe in Chatanfragen verarbeitet.',
      diarizationModel: 'Diarisierungsmodell',
      diarizationModelTip:
        'Das Standard-Diarisierungsmodell für sprecherattribuierte Transkription über die API.',
      ttsModel: 'TTS-Modell',
      ttsModelTip:
        'Auf Anfrage wird das Standard-TTS-Modell zur Sprachgenerierung während Gesprächen verwendet.',
      evalModel: 'Evaluations-Modell',
      evalModelTip:
        'Das Evaluations-Modell, welches zur Bewertung von Testszenarien genutzt werden soll (Judge-Model).',
      workspace: 'Arbeitsplatz',
      upgrade: 'Upgrade',
      addLlmTitle: 'LLM hinzufügen',
      modelName: 'Modellname',
      modelID: 'Modell-ID',
      modelUid: 'Modell-UID',
      modelNameMessage: 'Bitte geben Sie Ihren Modellnamen ein!',
      modelType: 'Modelltyp',
      modelTypeMessage: 'Bitte geben Sie Ihren Modelltyp ein!',
      addLlmBaseUrl: 'Basis-URL',
      baseUrlNameMessage: 'Bitte geben Sie Ihre Basis-URL ein!',
      vision: 'Unterstützt es Vision?',
      ollamaLink: 'So integrieren Sie {{name}}',
      FishAudioLink: 'So verwenden Sie FishAudio',
      TencentCloudLink: 'So verwenden Sie TencentCloud ASR',
      volcModelNameMessage: 'Bitte geben Sie Ihren Modellnamen ein!',
      addEndpointID: 'EndpointID des Modells',
      endpointIDMessage: 'Bitte geben Sie Ihre EndpointID des Modells ein',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Bitte geben Sie Ihren ARK_API_KEY ein',
      bedrockModelNameMessage: 'Bitte geben Sie Ihren Modellnamen ein!',
      addBedrockEngineAK: 'ZUGRIFFSSCHLÜSSEL',
      bedrockAKMessage: 'Bitte geben Sie Ihren ZUGRIFFSSCHLÜSSEL ein',
      addBedrockSK: 'GEHEIMSCHLÜSSEL',
      bedrockSKMessage: 'Bitte geben Sie Ihren SECRET KEY ein',
      bedrockRegion: 'AWS-Region',
      bedrockRegionMessage: 'Bitte auswählen!',
      'us-east-1': 'USA Ost (Nord-Virginia)',
      'us-west-2': 'USA West (Oregon)',
      'ap-südost-1': 'Asien-Pazifik (Singapur)',
      'ap-northeast-1': 'Asien-Pazifik (Tokio)',
      'eu-zentral-1': 'Europe (Frankfurt)',
      'us-gov-west-1': 'AWS GovCloud (USA-West)',
      'ap-südost-2': 'Asien-Pazifik (Sydney)',
      addHunyuanSID: 'Hu hätte lieber einen geheimen Ausweis',
      HunyuanSIDMessage: 'Bitte geben Sie Ihre Geheim-ID ein',
      addHunyuanSK: 'Hu hätte lieber einen geheimen Schlüssel',
      HunyuanSKMessage: 'Bitte geben Sie Ihren Geheimschlüssel ein',
      addTencentCloudSID: 'Geheime TencentCloud-ID',
      TencentCloudSIDMessage: 'Bitte geben Sie Ihre Geheim-ID ein',
      addTencentCloudSK: 'Geheimer TencentCloud-Schlüssel',
      TencentCloudSKMessage: 'Bitte geben Sie Ihren Geheimschlüssel ein',
      SparkModelNameMessage: 'Bitte wählen Sie das Spark-Modell aus',
      addSparkAPIPassword: 'Spark APIPassword',
      SparkAPIPasswordMessage: 'Bitte geben Sie Ihr APIPassword ein',
      addSparkAPPID: 'Spark-APP-ID',
      SparkAPPIDMessage: 'Bitte geben Sie Ihre APP-ID ein',
      addSparkAPISecret: 'Spark APISecret',
      SparkAPISecretMessage: 'Bitte geben Sie Ihr APISecret ein',
      addSparkAPIKey: 'Spark APIKey',
      SparkAPIKeyMessage: 'Bitte geben Sie Ihren APIKey ein',
      yiyanModelNameMessage: 'Bitte geben Sie den Modellnamen ein',
      addyiyanAK: 'Wählen Sie API-SCHLÜSSEL',
      yiyanAKMessage: 'Bitte geben Sie Ihren API-SCHLÜSSEL ein',
      addyiyanSK: 'Wählen Sie Secret KEY',
      yiyanSKMessage: 'Bitte geben Sie Ihren Geheimschlüssel ein',
      FishAudioModelNameMessage:
        'Bitte geben Sie Ihrem Sprachsynthesemodell einen Namen',
      addFishAudioAK: 'Fish Audio API-SCHLÜSSEL',
      addFishAudioAKMessage: 'Bitte geben Sie Ihren API-SCHLÜSSEL ein',
      addFishAudioRefID: 'FishAudio-Referenz-ID',
      addFishAudioRefIDMessage:
        'Bitte geben Sie die Referenz-ID ein (lassen Sie das Feld leer, um das Standardmodell zu verwenden).',
      GoogleModelIDMessage: 'Bitte geben Sie Ihre Modell-ID ein!',
      addGoogleProjectID: 'Projekt-ID',
      GoogleProjectIDMessage: 'Bitte geben Sie Ihre Projekt-ID ein',
      addGoogleServiceAccountKey:
        'Dienstkontoschlüssel (Leer lassen, wenn Sie Standardanmeldeinformationen für die Anwendung verwenden)',
      GoogleServiceAccountKeyMessage:
        'Bitte geben Sie den Google Cloud Service-Kontoschlüssel im Base64-Format ein',
      addGoogleRegion: 'Google Cloud-Region',
      GoogleRegionMessage: 'Bitte geben Sie die Google Cloud-Region ein',
      modelProvidersWarn: `Bitte fügen Sie sowohl das Einbettungsmodell als auch das LLM zunächst unter <b>Einstellungen > Modellanbieter</b> hinzu. Stellen Sie diese anschließend in 'Systemmodelleinstellungen' ein.`,
      evalModelWarn: `Bitte wählen Sie ein Evaluationsmodell unter <b>Einstellungen > Modellanbieter > Systemmodelleinstellungen</b> aus.`,
      apiVersion: 'API-Version',
      apiVersionMessage: 'Bitte geben Sie die API-Version ein',
      add: 'Hinzufügen',
      updateDate: 'Aktualisierungsdatum',
      role: 'Rolle',
      invite: 'Einladen',
      agree: 'Akzeptieren',
      refuse: 'Ablehnen',
      teamMembers: 'Teammitglieder',
      joinedTeams: 'Beigetretene Teams',
      sureDelete: 'Möchten Sie dieses Mitglied wirklich entfernen?',
      quit: 'Team verlassen',
      sureQuit:
        'Sind Sie sicher, dass Sie das Team, dem Sie beigetreten sind, verlassen möchten?',
      users: 'Benutzer',
      // Task-Warteschlangen (Superuser)
      queues: 'Warteschlangen',
      poolChat: 'Chat-Uploads',
      poolAnalyze: 'Dokumentenanalyse',
      poolCrawl: 'Crawls',
      queueSlots: '{{count}} Worker',
      queuePoolUnserved: 'kein Worker — läuft nicht',
      queuePoolSlotsHint:
        'Worker, die ausschließlich für diese Art von Arbeit zuständig sind; jeder führt eine Aufgabe zur Zeit aus. Jeder Worker bekommt seinen Bereich beim Start zugewiesen, deshalb kann ein Crawl nie einen Worker belegen, den die Dokumentenanalyse braucht, und umgekehrt. Null Worker bedeutet, dass diese Arbeit überhaupt nicht ausgeführt wird — sie staut sich stillschweigend auf. Die Aufteilung zu ändern erfordert einen Neustart der Task-Executor.',
      queueRunning: 'Läuft',
      queueWaiting: 'Wartet',
      queueTenantsWaiting: 'Wartende Mandanten',
      queueTenants: 'Pro Mandant',
      queueTenant: 'Mandant',
      queueActions: 'Aktionen',
      queueLaneCellHint:
        'läuft / wartet, danach die Wartezeit der ältesten wartenden Aufgabe und das 95. Perzentil der Startverzögerung. Ein mit „?“ markiertes Perzentil beruht auf weniger als {{count}} Messwerten und ist Rauschen.',
      queuePaused: 'Pausiert',
      queuePausedSince: 'Pausiert seit {{since}} von {{by}}',
      queuePause: 'Pausieren',
      queueResume: 'Fortsetzen',
      queuePauseNew: 'Neue Arbeit pausieren',
      queuePauseAll: 'Alles pausieren',
      queuePauseAllConfirm:
        'Neue Arbeit blockieren und die laufenden Crawls dieses Mandanten anhalten? Ein Crawl stoppt an der nächsten Batch-Grenze und behält seinen Stand, es geht also nichts verloren. Die Haltemarken bleiben bestehen, wenn Sie den Mandanten fortsetzen — heben Sie sie in der Crawl-Liste auf.',
      queueCancelQueued: 'Wartende abbrechen',
      queueCancelQueuedConfirm:
        'Wartende Aufgaben dieses Mandanten abbrechen? Laufende Arbeit wird zu Ende geführt.',
      queueCancelAll: 'Alles abbrechen',
      queueCancelAllConfirm:
        'Alles für diesen Mandanten abbrechen, auch die laufende Arbeit? Eine laufende Aufgabe lässt sich nicht sofort stoppen — sie endet am nächsten Prüfpunkt, was bei einem großen PDF bis zu 45 Minuten dauern kann.',
      queueCrawls: 'Crawls',
      queueCrawlName: 'Crawl',
      queueSegments: 'Abschnitte',
      queuePagesCrawled: 'Erfasste Seiten',
      queueCrawlUpdatedAt: 'Letzte Aktivität',
      queueSuspended: 'Wartet auf einen Platz',
      queueStopping: 'Wird beendet',
      queueNoActiveCrawls: 'Kein Crawl läuft oder wartet auf einen Platz.',
      queueCrawlRunning: 'Läuft',
      queueCrawlOrphaned: 'Verwaist',
      queueCrawlOrphanedHint:
        'Es wird nichts gecrawlt. Es gibt keine Aufgabe mehr, die diesen Lauf fortsetzen könnte — meist weil ein Worker mitten im Crawl beendet wurde —, der gemeldete Status ist also veraltet. Der Eintrag wird innerhalb weniger Minuten automatisch bereinigt, oder sofort über Abbrechen.',
      queueCrawlHeld: 'Von Administrator angehalten',
      queueCrawlHeldSince: ' seit {{since}} von {{by}}',
      queueCrawlHoldConfirm:
        'Diesen Crawl anhalten? Er stoppt an der nächsten Batch-Grenze und behält seinen Stand — es geht nichts verloren und er läuft von dort weiter, wenn Sie ihn fortsetzen.',
      queueWorkers: 'Worker',
      queueWorker: 'Worker',
      queuePool: 'Bereich',
      queueServers: 'Bedient von',
      queueHeartbeat: 'Letztes Lebenszeichen',
      queueDone: 'Fertig',
      queueFailed: 'Fehlgeschlagen',
      queueNoWorkers: 'Kein Task-Executor meldet sich.',
      queueConfig: 'Scheduler-Einstellungen',
      queueConfigSaved:
        'Gespeichert. Innerhalb weniger Sekunden überall wirksam.',
      queueConfig_queue_per_tenant: 'Aufgaben pro Mandant',
      queueConfigHint_queue_per_tenant:
        'Wie viele Plätze ein Mandant in einem Warteschlangen-Bereich gleichzeitig belegen darf. Weich: ein Platz bleibt nie leer, solange es Arbeit gibt.',
      queueConfig_chat_capacity: 'Plätze Chat-Uploads',
      queueConfigHint_chat_capacity:
        'Gleichzeitige Analysen aus dem Chat. Wirkt in beiden Richtungen innerhalb von Sekunden, ohne Neustart. Nicht deutlich höher setzen als die Zahl der Parse-Plätze im MinerU-Dienst — die zusätzlichen Uploads warten sonst dort und melden währenddessen „Analyse“.',
      queueConfig_chat_per_tenant: 'Chat-Uploads pro Mandant',
      queueConfigHint_chat_per_tenant:
        'Leer lassen, um den Bereich gleichmäßig unter den gerade Hochladenden zu teilen — dann bekommt ein einzelner Mandant auch alles.',
      queueConfig_chat_pause_wait_seconds: 'Wartezeit bei Pause (s)',
      queueConfigHint_chat_pause_wait_seconds:
        'Wie lange der Chat-Upload eines pausierten Mandanten wartet, bevor er mit einer Meldung abbricht. Wartende Dokumentenanalysen warten stattdessen unbegrenzt — ein Chat-Fenster kann das nicht.',
      queueConfig_crawl_slice_pages: 'Crawl-Abschnitt (Seiten)',
      queueConfigHint_crawl_slice_pages:
        'Seiten, die ein Crawl abrufen darf, bevor er seinen Platz einem Crawl eines anderen Mandanten anbietet. Wird bis auf einen Stapel genau eingehalten, ein paar Seiten mehr sind also normal.',
      queueConfig_crawl_slice_seconds: 'Crawl-Abschnitt (Sekunden)',
      queueConfigHint_crawl_slice_seconds:
        'Dieselbe Grenze in Zeit, es gilt was zuerst erreicht wird. Das deckt langsame oder gedrosselte Websites ab.',
      queueConfig_crawl_frontier_batch_size: 'Crawl-Stapelgröße',
      queueConfigHint_crawl_frontier_batch_size:
        'Wie viele URLs ein Crawl gleichzeitig abruft. Bestimmt auch, wie schnell ein Stopp wirkt, und wie genau die Abschnittsgrenzen eingehalten werden.',
      createUser: 'Benutzer erstellen',
      superuser: 'Superuser',
      status: 'Status',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      lastLogin: 'Letzte Anmeldung',
      searchUsers: 'Suche nach Spitzname oder E-Mail',
      resetPassword: 'Passwort zurücksetzen',
      sureResetPassword:
        'Möchten Sie das Passwort dieses Benutzers wirklich zurücksetzen? Es wird ein neues Passwort generiert.',
      userCreated: 'Benutzer erstellt',
      passwordReset: 'Passwort zurückgesetzt',
      oneTimePasswordWarning:
        'Kopieren Sie dieses Passwort jetzt — es wird nicht erneut angezeigt.',
      mcp: 'MCP-Werkzeuge',
      'mcp-servers': 'MCP-Server-Katalog',
      // Wofür die jeweilige MCP-Seite da ist, unter dem Titel angezeigt
      // (McpPageIntro).
      mcpServersIntro:
        'Der zentrale Katalog der MCP-Server. Jeden hier registrierten Server können alle Mandanten unter „MCP-Werkzeuge“ aktivieren.',
      mcpServersIntroItem1:
        'Server mit URL, Transport und – falls Zugangsdaten nötig sind – Konfigurationseigenschaften registrieren.',
      mcpServersIntroItem2:
        'Pro Eigenschaft festlegen, wer den Wert liefert: Sie, der Mandant oder die aufrufende Anwendung mit jeder Anfrage.',
      mcpServersIntroItem3:
        'Beim Speichern wird geprüft, ob der Server erreichbar ist, und seine Tools werden ausgelesen. Deaktivieren entzieht den Server allen Mandanten.',
      // Abschnitt „Erlaubte Domains“ auf der Katalogseite.
      mcpAllowedDomains: 'Erlaubte Domains für eigene Server der Mandanten',
      mcpAllowedDomainsIntro:
        'Unter „MCP-Werkzeuge“ können Mandanten eigene MCP-Server hinzufügen, allerdings nur für öffentlich erreichbare Adressen.',
      mcpAllowedDomainsIntroItem1:
        'Eine hier eingetragene Domain ist zusätzlich erlaubt: Mandanten können Server für sie hinzufügen, obwohl dies sonst abgelehnt würde.',
      mcpAllowedDomainsIntroItem2:
        'Geben Sie immer den Port an. Nur dieser Port wird geöffnet – alles andere auf demselben Server bleibt gesperrt.',
      mcpAllowedDomainsIntroItem3:
        'Tragen Sie nur Domains ein, denen Sie vertrauen – jeder Mandant darf sie dann verwenden. Wenn Sie eine entfernen, funktionieren die Server, die Mandanten dafür hinzugefügt haben, nicht mehr.',
      mcpAllowedDomainAdd: 'Domain hinzufügen',
      mcpAllowedDomainPlaceholder: 'mcp.example.com:8000',
      mcpNoAllowedDomains:
        'Noch keine Domains – Mandanten können nur öffentlich erreichbare Server hinzufügen.',
      mcpAllowedDomainRemove: 'Entfernen',
      mcpAllowedDomainRemoveConfirm: 'Diese Domain entfernen?',
      mcpAllowedDomainSaved: 'Domain hinzugefügt',
      mcpAllowedDomainRemoved: 'Domain entfernt',
      mcpToolsIntro:
        'Hier legen Sie fest, welche MCP-Server Ihre Chatbots verwenden dürfen – einen Server aus dem Katalog oder einen eigenen.',
      mcpToolsIntroItem1:
        'Server aus dem Katalog aktivieren und die verlangten Werte ausfüllen oder einen eigenen Server mit URL hinzufügen.',
      mcpToolsIntroItem2:
        'Auswählen, welche Tools Ihre Chatbots aufrufen dürfen; ohne Auswahl sind alle Tools erlaubt.',
      mcpToolsIntroItem3:
        'Aktivierte Konfigurationen lassen sich anschließend pro Chatbot in den Chatbot-Einstellungen unter „MCP-Werkzeuge“ auswählen.',
      mcpAddServer: 'Server hinzufügen',
      mcpEditServer: 'Server bearbeiten',
      mcpServerName: 'Name',
      mcpServerNameTip:
        'Wird den Nutzern angezeigt, wenn sie diesen Server aus dem Katalog auswählen.',
      mcpServerDescription: 'Beschreibung',
      mcpServerDescriptionTip:
        'Wird den Nutzern als Hinweis angezeigt, nachdem sie diesen Server ausgewählt haben. Erklären Sie, was der Server tut und welche Werte einzutragen sind.',
      mcpServerUrl: 'URL',
      mcpServerUrlTip:
        'Endpunkt des MCP-Servers inklusive Pfad, üblicherweise endend auf /mcp. Der Aufruf erfolgt vom Backend, daher sind interne Adressen oder Docker-Servicenamen möglich.',
      mcpServerUrlRule: 'Die URL muss mit http:// oder https:// beginnen',
      mcpTransport: 'Transport',
      mcpTransportTip:
        'Wie das Backend mit dem Server kommuniziert: „streamable-http“ für aktuelle MCP-Server, „sse“ nur für ältere Server mit Server-Sent-Events-Endpunkt.',
      mcpEnabled: 'Aktiviert',
      mcpServerEnabledTip:
        'Nur aktivierte Server erscheinen im Katalog der Nutzer. Deaktivieren blendet den Server aus und unterbindet alle Tool-Aufrufe.',
      mcpTools: 'Werkzeuge',
      mcpConfigProperties: 'Konfigurationseigenschaften',
      mcpNoConfigProperties:
        'Noch keine Konfigurationseigenschaften. Legen Sie für jeden HTTP-Header, den der Server erwartet, eine Eigenschaft an — z. B. für einen API-Key.',
      mcpNewProperty: 'Neue Eigenschaft',
      mcpAddProperty: 'Eigenschaft hinzufügen',
      mcpRemoveProperty: 'Eigenschaft entfernen',
      mcpPropKey: 'Schlüssel',
      mcpPropKeyTip:
        'Name des HTTP-Headers, mit dem der Wert gesendet wird, z. B. „Authorization“ oder „X-Api-Key“. Muss dem entsprechen, was der MCP-Server erwartet.',
      mcpPropLabel: 'Bezeichnung',
      mcpPropLabelTip:
        'Feldname, der dem Nutzer anstelle des Schlüssels angezeigt wird. Leer lassen, um den Schlüssel selbst anzuzeigen.',
      mcpPropDescription: 'Beschreibung',
      mcpPropDescriptionTip:
        'Hilfetext, der dem Nutzer am Eingabefeld angezeigt wird — woher der Wert kommt und welches Format er haben muss.',
      mcpPropSourceTip:
        'Wer den Wert liefert: fest von Ihnen gesetzt, ein von Nutzern überschreibbarer Standard, vom Nutzer auszufüllen oder von der aufrufenden Anwendung pro Anfrage übergeben (wird nie gespeichert).',
      mcpPropValue: 'Wert',
      mcpPropValueTip:
        'Der im Katalog gespeicherte Wert. Wird bei „Vom Admin gesetzt“ als Wert und bei „Admin-Standard“ als Vorbelegung verwendet; bei den anderen Typen leer lassen.',
      mcpPropPrefix: 'Präfix',
      mcpPropPrefixTip:
        'Wird dem Wert beim Senden des Headers vorangestellt. Für ein Bearer-Token „Bearer “ (mit Leerzeichen am Ende) verwenden, damit das gespeicherte Geheimnis nur das Token bleibt.',
      mcpPropSecret: 'Geheim',
      mcpPropSecretTip:
        'Der Wert wird als Zugangsdaten behandelt: maskierte Eingabe, und er wird nie an den Browser zurückgegeben.',
      mcpPropRequired: 'Pflichtfeld',
      mcpPropRequiredTip:
        'Ohne Wert für diese Eigenschaft kann die Konfiguration nicht gespeichert werden.',
      mcpSourceAdminFixed: 'Vom Admin gesetzt',
      mcpSourceAdminDefault: 'Admin-Standard',
      mcpSourceTenantInput: 'Vom Nutzer auszufüllen',
      mcpSourceRequestInput: 'Pro Anfrage übergeben',
      mcpPropKeyHeaderRule:
        'Nur Buchstaben, Ziffern und Bindestriche — ein Schlüssel mit Unterstrichen wird vom Reverse-Proxy verworfen.',
      mcpRequestHeaders: 'Anfrage-Header',
      mcpRequestInputTenantHint:
        'Dieser Server erwartet bei jeder Anfrage einen Wert von der aufrufenden Anwendung. Konfigurieren Sie die Anwendung mit dem hier angezeigten Header-Namen — der Wert wird nie gespeichert.',
      mcpRequestInputAdminHint:
        'Vorlage des Headers, den die aufrufende Anwendung senden muss. Der endgültige Name enthält die ID der MCP-Konfiguration des Nutzers und wird ihm auf der Seite „MCP-Werkzeuge“ angezeigt.',
      mcpRequestInputPendingId:
        'Der Header-Name enthält die ID dieses Eintrags und wird daher erst nach dem Speichern angezeigt.',
      mcpRequestInputNoToolsHint:
        'Die Werkzeuge dieses Servers können nur während einer Anfrage abgerufen werden. Lassen Sie die Auswahl leer, um alle zuzulassen.',
      mcpEdit: 'Bearbeiten',
      mcpDelete: 'Löschen',
      mcpDeleteConfirm: 'Diesen Eintrag löschen?',
      mcpSaved: 'Gespeichert',
      mcpConnectFailed: 'Verbindung zum MCP-Server fehlgeschlagen',
      // Die folgenden Keys liefert das Backend als `message` — siehe die
      // Message-Key-Konstanten in api/services/mcp_service.py. `{{detail}}` ist
      // der Wert, den der Service nach dem Trenner `::` mitsendet.
      mcpUnreachable:
        'Der MCP-Server ist nicht erreichbar. Bitte überprüfen Sie die URL und versuchen Sie es erneut.',
      mcpServerNotFound: 'Dieser MCP-Server existiert nicht mehr.',
      mcpServerNotFoundOrDisabled:
        'Dieser MCP-Server ist nicht verfügbar. Bitte wenden Sie sich an Ihre Administration.',
      mcpConfigNotFound: 'Diese MCP-Konfiguration existiert nicht mehr.',
      mcpCustomRequiresUrl: 'Bitte geben Sie die URL des MCP-Servers ein.',
      mcpDomainInvalid:
        'Bitte geben Sie eine gültige Domain mit Port ein, zum Beispiel mcp.example.com:8000.',
      mcpDomainRequiresPort:
        'Bitte ergänzen Sie den Port, zum Beispiel mcp.example.com:8000. Nur dieser Port wird geöffnet.',
      mcpDomainExists: '„{{detail}}“ steht bereits in der Liste.',
      mcpInvalidUrl:
        'Bitte geben Sie eine gültige http:// oder https:// URL ein.',
      mcpPrivateUrl:
        'Diese Adresse ist nicht zulässig. Bitte verwenden Sie eine öffentlich erreichbare URL oder bitten Sie Ihre Administration, den Server in den Katalog aufzunehmen.',
      mcpMissingConfig:
        'Bitte füllen Sie die erforderliche Konfiguration aus: {{detail}}',
      mcpServerImmutable:
        'Der Server einer bestehenden MCP-Konfiguration kann nicht geändert werden. Bitte legen Sie einen neuen Eintrag an.',
      mcpPropKeyInvalid:
        'Der Konfigurationsschlüssel „{{detail}}“ ist kein gültiger Header-Name. Bitte verwenden Sie nur Buchstaben, Ziffern und Bindestriche.',
      mcpPropKeyReserved:
        '„{{detail}}“ ist für die eigenen Anfrage-Header von Buddy reserviert. Bitte wählen Sie einen anderen Schlüssel.',
      mcpPropKeyDuplicate:
        'Der Konfigurationsschlüssel „{{detail}}“ wird zweimal verwendet. Bitte verwenden Sie jeden Schlüssel nur einmal.',
      mcpPropKeyCatalogOwned:
        'Der Server definiert „{{detail}}“ bereits selbst. Bitte wählen Sie einen anderen Schlüssel.',
      mcpTenantSourceNotAllowed:
        'Der Eigenschaftstyp „{{detail}}“ kann nur von der Administration gesetzt werden.',
      mcpAddConfig: 'MCP-Server hinzufügen',
      mcpEditConfig: 'MCP-Server bearbeiten',
      mcpMode: 'Typ',
      mcpModeCatalog: 'Aus Katalog',
      mcpModeCustom: 'Eigener Server',
      mcpServer: 'Server',
      mcpSelectedTools: 'Aktive Werkzeuge',
      mcpSelectedToolsTip:
        'Leer lassen, um alle Werkzeuge des Servers für Ihre Chatbots verfügbar zu machen.',
      mcpAllTools: 'Alle Werkzeuge',
      mcpAllowedTools: 'Erlaubte Werkzeuge',
      mcpAllowedToolsTip:
        'Welche Werkzeuge dieses Servers Nutzer aktivieren dürfen. Leer lassen, um alle zu erlauben.',
      mcpSourceType: 'Typ',
      mcpSecretSet: '•••••• (gesetzt — leer lassen zum Beibehalten)',
      mcpCustomToolsHint:
        'Werkzeuge werden automatisch erkannt, sobald Sie speichern und sich mit dem Server verbinden.',
      mcpExtraProperties: 'Zusätzliche Header',
      mcpExtraPropertiesHint:
        'Header, die zusätzlich zu den oben vom Server vorgegebenen gesendet werden. Schlüssel, die der Server selbst definiert, können hier nicht überschrieben werden.',
      mcpOwnPropertiesHint:
        'Header, die an Ihren Server gesendet werden, zum Beispiel ein API-Schlüssel oder ein Autorisierungs-Token. Der Schlüssel ist der Header-Name.',
      mcpTenantPropValueTip:
        'Der Wert, der als dieser Header gesendet wird. Ein geheimer Wert wird maskiert gespeichert und nicht wieder angezeigt — lassen Sie das Feld leer, um ihn beizubehalten.',
      mcpTenantSourceTip:
        '„Von Nutzer gefüllt“ verwendet den Wert, den Sie hier eintragen. „Pro Anfrage übergeben“ erwartet ihn bei jeder Anfrage von der aufrufenden Anwendung und speichert nichts.',
      mcpPropKeyReservedRule:
        'Dieser Schlüssel ist für die eigenen Anfrage-Header von Buddy reserviert.',
      mcpPropKeyDuplicateRule:
        'Dieser Schlüssel wird bereits von einer anderen Eigenschaft verwendet.',
      mcpPropKeyCatalogOwnedRule:
        'Der Server definiert diesen Schlüssel bereits selbst.',
      mcpCacheTools: 'Werkzeuge zwischenspeichern',
      mcpCacheToolsTip:
        'Die Werkzeug-Schemata in der Datenbank speichern, anstatt sie bei jeder Nutzung vom Server abzurufen. Schneller, aber Änderungen am Server werden erst nach einer Aktualisierung sichtbar. Beim Speichern wird der Cache erneuert.',
      mcpRefreshTools: 'Werkzeuge aktualisieren',
      mcpClearCache: 'Cache leeren',
      mcpToolsRefreshed: '{{num}} Werkzeuge gefunden',
      mcpToolsCached: '{{num}} zwischengespeichert',
      mcpToolsLive: 'live',
      mcpActions: 'Aktionen',
    },
    message: {
      logout: 'Abmelden',
      logged: 'Angemeldet!',
      pleaseSelectChunk: 'Bitte Chunk auswählen!',
      modified: 'Bearbeitet',
      created: 'Erstellt',
      deleted: 'Gelöscht',
      downloadFailed: 'Download fehlgeschlagen.',
      renamed: 'Umbenannt',
      operated: 'Ausgeführt',
      updated: 'Aktualisiert',
      uploaded: 'Hochgeladen',
      200: 'Der Server gibt die angeforderten Daten erfolgreich zurück.',
      201: 'Daten erfolgreich erstellen oder ändern.',
      202: 'Im Hintergrund wurde eine Anfrage in die Warteschlange gestellt (asynchrone Aufgabe).',
      204: 'Daten erfolgreich gelöscht.',
      400: 'In der ausgegebenen Anfrage ist ein Fehler aufgetreten und der Server hat keine Daten erstellt oder geändert.',
      401: 'Der Benutzer verfügt nicht über Berechtigungen (falscher Token, Benutzername, Passwort).',
      403: 'Der Benutzer ist berechtigt, der Zugriff ist jedoch verboten.',
      404: 'Die Anforderung wurde für einen Datensatz gestellt, der nicht vorhanden ist, und der Server hat den Vorgang nicht ausgeführt.',
      406: 'Das angeforderte Format ist nicht verfügbar.',
      410: 'Die angeforderte Ressource wurde endgültig gelöscht und ist nicht mehr verfügbar.',
      413: 'Die Gesamtgröße der gleichzeitig hochgeladenen Dateien ist zu groß.',
      422: 'Beim Erstellen eines Objekts ist ein Validierungsfehler aufgetreten.',
      429: 'Zu viele Anfragen. Bitte etwas langsamer und nach einer Minute erneut versuchen.',
      500: 'Es ist ein Serverfehler aufgetreten. Bitte überprüfen Sie den Server.',
      502: 'Gateway-Fehler.',
      503: 'Der Dienst ist nicht verfügbar und der Server ist vorübergehend überlastet oder wird gerade gewartet.',
      504: 'Gateway-Timeout.',
      requestError: 'Fehler bei der Anfrage',
      networkAnomalyDescription:
        'In Ihrem Netzwerk liegt eine Anomalie vor und Sie können keine Verbindung zum Server herstellen.',
      networkAnomaly: 'Netzwerkanomalie',
      hint: 'Hinweis',
    },
    fileManager: {
      name: 'Name',
      uploadDate: 'Upload-Datum',
      knowledgeBase: 'Wissensdatenbank',
      size: 'Größe',
      action: 'Aktion',
      addToKnowledge: 'Link zur Wissensdatenbank',
      pleaseSelect: 'Bitte auswählen',
      newFolder: 'Neuer Ordner',
      file: 'Datei',
      uploadFile: 'Datei hochladen',
      directory: 'Verzeichnis',
      uploadTitle:
        'Klicken oder ziehen Sie die Datei zum Hochladen in diesen Bereich',
      uploadDescription:
        'Unterstützung für einen einzelnen oder Massen-Upload. Das Hochladen von Unternehmensdaten oder anderen verbotenen Dateien ist strengstens untersagt.',
      local: 'Lokale Uploads',
      s3: 'S3-Uploads',
      website: 'Webseite',
      preview: 'Vorschau',
      fileError: 'Dateifehler',
      uploadLimit:
        'Die Dateigröße darf 10 MB nicht überschreiten und die Gesamtzahl der Dateien darf 128 nicht überschreiten',
      destinationFolder: 'Zielordner',
      replacingExistingFilesWarning:
        'Die nachfolgenden Dateien werden mit diesem Upload überschrieben:',
    },
    feedback: {
      reportProblem: 'Problem melden',
      sendFeedback: 'Feedback senden',
      report: 'Melden',
      send: 'Absenden',
      reportProblemDescription:
        'Die Antwort ist nicht in Ordnung? Bitte geben Sie an, welcher Art das Problem ist. Wir werden uns dann diese eine Chat-Session anonymisiert ansehen.',
      sendFeedbackDescription:
        'Vielen Dank für das Feedback! Gerne können Sie uns auch optional noch einen Kommentar hinterlassen.',
      freetextCommentPlaceholder: 'Kommentar (optional)',
      editHint: 'Bitte wählen Sie eine Antwortoption aus',
      answer: {
        wrong: 'Falsch',
        harmful: 'Gefährlich/Schädlich/Illegal',
        offensive: 'Anstößig/Diskriminierend/Unfair',
        repetition: 'Wiederholung',
        unclear: 'Unklar',
        insufficient: 'Unzureichend',
        other: 'Sonstiges',
      },
    },
    flow: {
      cite: 'Zitieren',
      citeTip: 'ZitierenTipp',
      name: 'Name',
      nameMessage: 'Bitte geben Sie den Namen ein',
      description: 'Beschreibung',
      examples: 'Beispiele',
      to: 'Zu',
      msg: 'Nachrichten',
      messagePlaceholder: 'Nachricht',
      messageMsg:
        'Bitte geben Sie eine Nachricht ein oder löschen Sie dieses Feld.',
      addField: 'Option hinzufügen',
      addMessage: 'Nachricht hinzufügen',
      loop: 'Schleife',
      loopTip:
        'Schleife ist die Obergrenze der Anzahl der Schleifen der aktuellen Komponente. Wenn die Anzahl der Schleifen den Wert der Schleife überschreitet, bedeutet dies, dass die Komponente die aktuelle Aufgabe nicht abschließen kann. Bitte optimieren Sie den Agenten erneut',
      yes: 'Ja',
      no: 'NEIN',
      key: 'Schlüssel',
      componentId: 'Komponenten-ID',
      add: 'Hinzufügen',
      operation: 'Operation',
      run: 'Ausführen',
      save: 'Speichern',
      title: 'ID:',
      beginDescription: 'Hier beginnt der Fluss.',
      answerDescription: `Eine Komponente, die als Schnittstelle zwischen Mensch und Bot dient, Benutzereingaben empfängt und die Antworten des Agenten anzeigt.`,
      retrievalDescription: `Eine Komponente, die Informationen aus einer bestimmten Wissensdatenbank abruft und „Leere Antwort“ zurückgibt, wenn keine Informationen gefunden werden. Stellen Sie sicher, dass die richtige Wissensdatenbank ausgewählt ist.`,
      generateDescription: `Eine Komponente, die das Sprachmodell dazu auffordert, Antworten zu generieren. Stellen Sie sicher, dass die Eingabeaufforderung richtig eingestellt ist.`,
      categorizeDescription: `Eine Komponente, die das Sprachmodell verwendet, um Benutzereingaben in vordefinierte Kategorien zu klassifizieren. Stellen Sie sicher, dass Sie für jede Kategorie den Namen, die Beschreibung und Beispiele sowie die entsprechende nächste Komponente angeben.`,
      relevantDescription: `Eine Komponente, die das Sprachmodell verwendet, um zu beurteilen, ob die vorgelagerte Ausgabe für die letzte Abfrage des Benutzers relevant ist. Stellen Sie sicher, dass Sie die nächste Komponente für jedes Beurteilungsergebnis angeben.`,
      rewriteQuestionDescription: `Eine Komponente, die eine Benutzeranfrage verfeinert, wenn sie keine relevanten Informationen aus der Wissensdatenbank abrufen kann. Sie wiederholt diesen Prozess, bis die vordefinierte Obergrenze für die Schleife erreicht ist. Stellen Sie sicher, dass ihr Upstream „Relevant“ und ihr Downstream „Wissensabruf“ ist. `,
      messageDescription:
        "Eine Komponente, die eine statische Nachricht aussendet. Wenn mehrere Nachrichten geliefert werden, wählt sie eine zufällig aus, um sie zu senden. Achten Sie darauf, dass ihr Downstream die Schnittstellenkomponente 'Antwort' ist.",
      keywordDescription: `Eine Komponente, die die N besten Suchergebnisse aus den Benutzereingaben abruft. Stellen Sie sicher, dass der TopN-Wert vor der Verwendung richtig eingestellt ist.`,
      switchDescription: `Eine Komponente, die Bedingungen basierend auf der Ausgabe vorheriger Komponenten auswertet und den Ausführungsfluss entsprechend steuert. Es ermöglicht eine komplexe Verzweigungslogik, indem Fälle definiert und Aktionen für jeden Fall oder Standardaktionen festgelegt werden, wenn keine Bedingungen erfüllt sind.`,
      wikipediaDescription: `Eine Komponente, die von wikipedia.org aus sucht und TopN verwendet, um die Anzahl der Suchergebnisse anzugeben. Es ergänzt die bestehenden Wissensdatenbanken.`,
      promptText: `Bitte fassen Sie die folgenden Absätze zusammen. Seien Sie vorsichtig mit den Zahlen, erfinden Sie keine Dinge. Absätze wie folgt:
        {input}
  Der obige Text ist der Inhalt, den Sie zusammenfassen müssen.`,
      createGraph: 'Bot erstellen',
      createFromTemplates: 'Erstellen Sie aus Vorlagen',
      retrieval: 'Wissensabruf',
      generate: 'Generieren',
      answer: 'Interagieren',
      categorize: 'Kategorisieren',
      relevant: 'Relevant',
      rewriteQuestion: 'Umschreiben',
      rewrite: 'Umschreiben',
      begin: 'Start',
      message: 'Nachricht',
      blank: 'Leer',
      createFromNothing: 'Erstellen Sie Ihren Bot von Grund auf',
      addItem: 'Artikel hinzufügen',
      addSubItem: 'Unterelement hinzufügen',
      nameRequiredMsg: 'Name ist erforderlich',
      nameRepeatedMsg: 'Der Name kann nicht wiederholt werden',
      keywordExtract: 'Stichwort',
      keywordExtractDescription: `Eine Komponente, die Schlüsselwörter aus einer Benutzerabfrage extrahiert, wobei Top N die Anzahl der zu extrahierenden Schlüsselwörter angibt.`,
      baidu: 'Baidu',
      baiduDescription: `Eine Komponente, die von baidu.com aus sucht und TopN verwendet, um die Anzahl der Suchergebnisse anzugeben. Es ergänzt die bestehenden Wissensdatenbanken.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'Eine Komponente, die von duckduckgo.com aus sucht und es Ihnen ermöglicht, die Anzahl der Suchergebnisse mithilfe von TopN anzugeben. Es ergänzt die bestehenden Wissensdatenbanken.',
      channel: 'Kanal',
      channelTip: `Perform text search or news search on the component's input`,
      text: 'Text',
      news: 'Nachricht',
      messageHistoryWindowSize: 'Größe des Nachrichtenfensters',
      messageHistoryWindowSizeTip:
        'Die Fenstergröße des Konversationsverlaufs, die von LLM angezeigt werden musste. Je größer desto besser. Seien Sie jedoch vorsichtig mit der maximalen Inhaltslänge von LLM.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription:
        'Eine Komponente, die von https://pubmed.ncbi.nlm.nih.gov/ aus sucht und es Ihnen ermöglicht, die Anzahl der Suchergebnisse mithilfe von TopN anzugeben. Es ergänzt die bestehenden Wissensdatenbanken.',
      email: 'E-Mail',
      emailTip:
        'E-Mail ist ein Pflichtfeld. Hier müssen Sie eine E-Mail-Adresse eingeben.',
      arXiv: 'ArXiv',
      arXivDescription:
        'Eine Komponente, die von https://arxiv.org/ aus sucht und es Ihnen ermöglicht, die Anzahl der Suchergebnisse mithilfe von TopN anzugeben. Es ergänzt die bestehenden Wissensdatenbanken.',
      sortBy: 'Sortieren nach',
      submittedDate: 'Datum der Einreichung',
      lastUpdatedDate: 'Datum der letzten Aktualisierung',
      relevance: 'Relevanz',
      google: 'Google',
      googleDescription:
        'Eine Komponente, die von https://www.google.com/ aus sucht und es Ihnen ermöglicht, die Anzahl der Suchergebnisse mithilfe von TopN anzugeben. Es ergänzt die bestehenden Wissensdatenbanken. Bitte beachten Sie, dass hierfür ein API-Schlüssel von serpapi.com erforderlich ist.',
      bing: 'Bing',
      bingDescription:
        'Eine Komponente, die von https://www.bing.com/ aus sucht und es Ihnen ermöglicht, die Anzahl der Suchergebnisse mithilfe von TopN anzugeben. Es ergänzt die bestehenden Wissensdatenbanken. Bitte beachten Sie, dass hierfür ein API-Schlüssel von microsoft.com erforderlich ist.',
      apiKey: 'API-SCHLÜSSEL',
      country: 'Land und Region',
      language: 'Sprache',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'Eine Komponente, die https://scholar.google.com/ durchsucht. Mit Top N können Sie die Anzahl der Suchergebnisse angeben.',
      yearLow: 'Jahrestief',
      yearHigh: 'Jahreshoch',
      patents: 'Patente',
      data: 'Daten',
      deepL: 'DeepL',
      deepLDescription:
        'Eine Komponente, die speziellere Übersetzungen von https://www.deepl.com/ erhält.',
      authKey: 'Authentifizierungsschlüssel',
      sourceLang: 'Ausgangssprache',
      targetLang: 'Zielsprache',
      gitHub: 'GitHub',
      gitHubDescription:
        'Eine Komponente, die nach Repositorys von https://github.com/ sucht. Mit Top N können Sie die Anzahl der Suchergebnisse angeben.',
      baiduFanyi: 'Baidu Do',
      baiduFanyiDescription:
        'Eine Komponente, die Fachübersetzungen von https://fanyi.baidu.com/ erhält.',
      appid: 'App-ID',
      secretKey: 'Geheimer Schlüssel',
      domain: 'Domain',
      transType: 'Übersetzungstyp',
      baiduSecretKeyOptions: {
        translate: 'Allgemeine Übersetzung',
        fieldtranslate: 'Feldübersetzung',
      },
      baiduDomainOptions: {
        it: 'Informationstechnologie',
        finance: 'Finanz- und Wirtschaftswissenschaften',
        machinery: 'Maschinenbau',
        senimed: 'Biomedizin',
        novel: 'Online-Literatur',
        academic: 'Akademische Arbeit',
        aerospace: 'Luft- und Raumfahrt',
        wiki: 'Geistes- und Sozialwissenschaften',
        news: 'Neuigkeiten und Informationen',
        law: 'Gesetze und Vorschriften',
        contract: 'Vertrag',
      },
      baiduSourceLangOptions: {
        auto: 'Automatische Erkennung',
        zh: 'chinesisch',
        en: 'Englisch',
        yue: 'Kantonesisch',
        wyw: 'Klassisches Chinesisch',
        jp: 'japanisch',
        kor: 'Koreanisch',
        fra: 'Französisch',
        spa: 'Spanisch',
        th: 'Thailändisch',
        ara: 'Arabisch',
        ru: 'Russisch',
        pt: 'Portugiesisch',
        de: 'Deutsch',
        it: 'Italienisch',
        el: 'griechisch',
        nl: 'Niederländisch',
        pl: 'Polnisch',
        bul: 'bulgarisch',
        est: 'estnisch',
        dan: 'dänisch',
        fin: 'finnisch',
        cs: 'tschechisch',
        rom: 'rumänisch',
        slo: 'Slowenisch',
        swe: 'Schwedisch',
        hu: 'ungarisch',
        cht: 'Traditionelles Chinesisch',
        vie: 'Vietnamesisch',
      },
      qWeather: 'QWetter',
      qWeatherDescription:
        'Eine Komponente, die Wetterinformationen wie Temperatur und Luftqualität von https://www.qweather.com/ abruft.',
      lang: 'Sprache',
      type: 'Typ',
      webApiKey: 'Web-API-Schlüssel',
      userType: 'Benutzertyp',
      timePeriod: 'Zeitraum',
      qWeatherLangOptions: {
        zh: 'Vereinfachtes Chinesisch',
        'zh-hant': 'Traditionelles Chinesisch',
        en: 'Englisch',
        de: 'Deutsch',
        es: 'Spanisch',
        fr: 'Französisch',
        it: 'Italienisch',
        ja: 'japanisch',
        ko: 'Koreanisch',
        ru: 'Russisch',
        hi: 'Nein',
        th: 'Thailändisch',
        ar: 'Arabisch',
        pt: 'Portugiesisch',
        bn: 'Bengali',
        ms: 'malaiisch',
        nl: 'Niederländisch',
        el: 'griechisch',
        la: 'lateinisch',
        sv: 'Schwedisch',
        id: 'Indonesisch',
        pl: 'Polieren',
        tr: 'Türkisch',
        cs: 'tschechisch',
        et: 'estnisch',
        vi: 'Vietnamesisch',
        fil: 'Philippinisch',
        fi: 'finnisch',
        he: 'hebräisch',
        is: 'isländisch',
        nb: 'norwegisch',
      },
      qWeatherTypeOptions: {
        weather: 'Wettervorhersage',
        indices: 'Wetterlebensindex',
        airquality: 'Luftqualität',
      },
      qWeatherUserTypeOptions: {
        free: 'Kostenloser Abonnent',
        paid: 'Bezahlter Abonnent',
      },
      qWeatherTimePeriodOptions: {
        now: 'Jetzt',
        Gebäude: '3 Tage',
        Ende: '7 Tage',
        '10d': '10 Tage',
        '15d': '12 Tage',
        '30d': '30 Tage',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'Eine Komponente, die SQL-Abfragen in einer relationalen Datenbank ausführt und Abfragen von MySQL, PostgreSQL oder MariaDB unterstützt.',
      dbType: 'Datenbanktyp',
      database: 'Datenbank',
      username: 'Benutzername',
      host: 'Host',
      port: 'Port',
      password: 'Passwort',
      switch: 'Switch',
      logicalOperator: 'Logischer Operator',
      switchOperatorOptions: {
        equal: 'gleich',
        notEqual: 'notEqual',
        gt: 'Größer als',
        ge: 'Größer gleich',
        lt: 'Weniger als',
        le: 'Weniger gleich',
        contains: 'Enthält',
        notContains: 'Nicht enthalten',
        startWith: 'Beginnen Sie mit',
        endWith: 'Schluss mit',
        empty: 'Leer',
        notEmpty: 'Nicht leer',
      },
      switchLogicOperatorOptions: {
        and: 'Und',
        or: 'Oder',
      },
      operator: 'Operator',
      value: 'Wert',
      useTemplate: 'Verwenden Sie diese Vorlage',
      wenCai: 'wenCAI',
      queryType: 'Abfragetyp',
      wenCaiDescription:
        'Eine Komponente, die Finanzinformationen, einschließlich Aktienkurse und Finanzierungsnachrichten, von einer Vielzahl von Finanzwebsites abruft.',
      wenCaiQueryTypeOptions: {
        stock: 'Aktie',
        zhishu: 'Index',
        fund: 'Fonds',
        hkstock: 'Hongkonger Aktien',
        usstock: 'US-Aktienmarkt',
        threeboard: 'Neuer OTC-Markt',
        conbond: 'Wandelanleihe',
        insurance: 'Versicherung',
        futures: 'Futures',
        lccp: 'Finanzierung',
        foreign_exchange: 'Fremdwährung',
      },
      akShare: 'akShare',
      akShareDescription:
        'Eine Komponente, die Nachrichten über Aktien von https://www.eastmoney.com/ erhält.',
      yahooFinance: 'Yahoo Finanzen',
      yahooFinanceDescription:
        'Eine Komponente, die Informationen über ein börsennotiertes Unternehmen anhand seines Tickersymbols abfragt.',
      crawler: 'Webcrawler',
      crawlerDescription:
        'Eine Komponente, die HTML-Quellcode von einer angegebenen URL crawlt.',
      proxy: 'Proxy',
      crawlerResultOptions: {
        html: 'HTML',
        markdown: 'Markdown',
        content: 'Inhalt',
      },
      extractType: 'Typ extrahieren',
      info: 'Info',
      history: 'Geschichte',
      financials: 'Finanzen',
      balanceSheet: 'Bilanz',
      cashFlowStatement: 'Kapitalflussrechnung',
      jin10: 'Jin10',
      jin10Description:
        'Eine Komponente, die Finanzinformationen von der Jin10 Open Platform abruft, einschließlich Nachrichtenaktualisierungen, Kalender, Zitate und Referenzen.',
      flashType: 'Blitztyp',
      filter: 'Filter',
      contain: 'Enthalten',
      calendarType: 'Kalendertyp',
      calendarDatashape: 'Kalenderdatenform',
      symbolsDatatype: 'Symboldatentyp',
      symbolsType: 'Symboltyp',
      jin10TypeOptions: {
        flash: 'Schnelle Neuigkeiten',
        calendar: 'Kalender',
        symbols: 'Zitate',
        news: 'Referenz',
      },
      jin10FlashTypeOptions: {
        '1': 'Marktnachrichten',
        '2': 'Futures-Nachrichten',
        '3': 'Nachrichten aus den USA und Hongkong',
        '4': 'A-Share-Neuigkeiten',
        '5': 'Rohstoffe und Forex-Nachrichten',
      },
      jin10CalendarTypeOptions: {
        cj: 'Makroökonomischer Datenkalender',
        qh: 'Futures-Kalender',
        hk: 'Börsenkalender für Hongkong',
        us: 'US-Börsenkalender',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Daten',
        event: 'Ereignis',
        holiday: 'Urlaub',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Rohstoffkurse',
        FOREX: 'Forex-Kurse',
        FUTURE: 'Internationale Marktkurse',
        CRYPTO: 'Kryptowährungszitate',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Warenliste',
        quotes: 'Aktuelle Marktkurse',
      },
      concentrator: 'Konzentrator',
      concentratorDescription:
        'Eine Komponente, die die Ausgabe der Upstream-Komponente empfängt und als Eingabe an die Downstream-Komponenten weitergibt.',
      tuShare: 'Frost',
      tuShareDescription:
        'Eine Komponente, die Finanznachrichten von gängigen Finanzwebsites abruft und so die Industrie und quantitative Forschung unterstützt.',
      tuShareSrcOptions: {
        sina: 'Ihre',
        wallstreetcn: 'wallstreetcn',
        '10 jqka': 'Straight Flush',
        eastmoney: 'Eastmoney',
        yuncaijing: 'Y UNC AI J ing',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'schäbig',
      },
      token: 'Token',
      src: 'Quelle',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      keyword: 'Stichwort',
      note: 'Notiz',
      noteDescription: 'Notiz',
      notePlaceholder: 'Bitte geben Sie eine Notiz ein',
      invoke: 'Aufrufen',
      invokeDescription: `A component capable of calling remote services, using other components' outputs or constants as inputs.`,
      url: 'URL',
      method: 'Verfahren',
      timeout: 'Time-out',
      headers: 'Überschriften',
      cleanHtml: 'Sauberes HTML',
      cleanHtmlTip:
        'Wenn die Antwort HTML-formatiert ist und nur der primäre Inhalt gewünscht wird, schalten Sie sie bitte ein.',
      reference: 'Referenz',
      input: 'Eingang',
      output: 'Ausgabe',
      parameter: 'Parameter',
      howUseId: 'Wie verwende ich die Agenten-ID?',
      content: 'Inhalt',
      operationResults: 'Operationsergebnisse',
      autosaved: 'Automatisch gespeichert',
      optional: 'Optional',
      pasteFileLink: 'Dateilink einfügen',
      testRun: 'Probelauf',
      template: 'Vorlage',
      templateDescription:
        'Eine Komponente, die die Ausgabe einer anderen Komponente formatiert.',
      emailComponent: 'E-Mail',
      emailDescription: 'Senden Sie eine E-Mail an eine angegebene Adresse.',
      smtpServer: 'SMTP-Server',
      smtpPort: 'SMTP-Port',
      senderEmail: 'Sender Email',
      authCode: 'Autorisierungscode',
      senderName: 'Sender Name',
      toEmail: 'Empfänger-E-Mail',
      ccEmail: 'CC-E-Mail',
      emailSubject: 'Thema',
      emailContent: 'Inhalt',
      smtpServerRequired: 'Bitte geben Sie die SMTP-Serveradresse ein',
      senderEmailRequired:
        'Bitte geben Sie die E-Mail-Adresse des Absenders ein',
      authCodeRequired: 'Bitte geben Sie den Autorisierungscode ein',
      toEmailRequired: 'Bitte geben Sie die E-Mail-Adresse des Empfängers ein',
      emailContentRequired: 'Bitte geben Sie den E-Mail-Inhalt ein',
      emailSentSuccess: 'E-Mail erfolgreich gesendet',
      emailSentFailed: 'E-Mail konnte nicht gesendet werden',
      dynamicParameters: 'Dynamische Parameter',
      jsonFormatTip:
        'Die Upstream-Komponente sollte eine JSON-Zeichenfolge im folgenden Format bereitstellen:',
      toEmailTip: 'to_email: E-Mail des Empfängers (erforderlich)',
      ccEmailTip: 'cc_email: CC-E-Mail (optional)',
      subjectTip: 'Betreff: E-Mail-Betreff (optional)',
      contentTip: 'Inhalt: E-Mail-Inhalt (optional)',
      jsonUploadTypeErrorMessage: 'Bitte laden Sie die JSON-Datei hoch',
      jsonUploadContentErrorMessage: 'JSON-Dateifehler',
      iteration: 'Iteration',
      iterationDescription: `Diese Komponente teilt zunächst die Eingabe in ein Array durch „Trennzeichen“ auf.
Sie führt dieselben Arbeitsschritte nacheinander an den Elementen im Array durch, bis alle Ergebnisse ausgegeben sind, was als Aufgabenstapelverarbeitung verstanden werden kann.

Wenn beispielsweise innerhalb des Iterationsknotens für die Langtextübersetzung der gesamte Inhalt in den Sprachmodell-Knoten eingegeben wird, kann die Grenze für eine einzige Konversation erreicht werden. Der vorgelagerte Knoten kann den Langtext zunächst in mehrere Fragmente aufteilen und mit dem iterativen Knoten zusammenarbeiten, um eine Stapelübersetzung für jedes Fragment durchzuführen, damit das Sprachmodell-Nachrichtenlimit für eine einzelne Konversation nicht erreicht wird.`,
      delimiterTip: `
Dieses Trennzeichen wird verwendet, um den Eingabetext in mehrere Textstücke aufzuteilen, von denen ein Echo als Eingabeelement jeder Iteration ausgeführt wird.`,
      delimiterOptions: {
        comma: 'Komma',
        lineBreak: 'Zeilenumbruch',
        tab: 'Tab',
        underline: 'Unterstreichen',
        diagonal: 'Diagonale',
        minus: 'Minus',
        semicolon: 'Semikolon',
      },
      addVariable: 'Variable hinzufügen',
      variableSettings: 'Variable Einstellungen',
      globalVariables: 'Globale Variablen',
      systemPrompt: 'Systemaufforderung',
    },
    footer: {
      profile: 'Alle Rechte vorbehalten @ React',
    },
    layout: {
      file: 'Datei',
      knowledge: 'Wissen',
      chat: 'chatten',
    },
    reAnalyzeModal: {
      message: 'Möchten Sie alle bereits existierenden Chunks löschen?',
      warningText:
        'Vorsicht: Manuelle Änderungen an Chunks gehen hierbei verloren.',
      manageChunks: 'Chunks verwalten',
      cancel: 'Abbrechen',
      keep: 'Behalten',
      continue: 'Fortsetzen',
      delete: 'Löschen',
    },
    setTagsModal: {
      message:
        'Hier können Sie die Stichwörter aller ausgewählten Dateien einsehen und bearbeiten. Es werden jedoch nur diejenigen Stichwörter angezeigt, die alle Chunks einer Datei gemein haben, sowie über alle Dateien hinweg gleich sind.',
      warningMessage:
        '**Bitte berücksichtigen Sie, dass sofern für eine ausgewählte Datei keine Chunks existieren, keine Stichwörter angelegt werden können.**',
      manageTags: 'Stichwörter verwalten',
      tags: 'Stichwörter',
      apply: 'Übernehmen',
    },
    evaluation: {
      evaluation: 'Auswertung',
      question: 'Frage',
      answer: 'Antwort',
      feedback: 'Feedback',
      actions: 'Aktionen',
      showHistory: 'Verlauf anzeigen',
      dialogNotFound: 'Dialog nicht gefunden',
      export: 'Exportieren',
      positiveFeedbacks: 'Positive Feedbacks',
      negativeFeedbacks: 'Negative Feedbacks',
      allMessages: 'Alle Nachrichten',
      showTotalLabel: `Insgesamt {{total}} Feedbacks`,
      fromStart: 'Vom Beginn an',
      untilNow: 'Bis jetzt',
      filterDateRange: 'Datumsbereich filtern',
      sessions: 'Sitzungen',
      activeSessions: 'Aktive Sitzungen',
      interactions: 'Interaktionen',
      meanInteractionsPerActiveSession: '⌀ Interaktionen pro Sitzung',
      ratedAnswers: 'Bewertete Antworten',
      likes: '  ↳ Gefällt mir',
      dislikes: '  ↳ Gefällt mir nicht',
      feedbackAndMessages: 'Feedback & Nachrichten',
      feedbackFlagCountsLabel: 'Anzahl der Feedback-Flags',
      feedbackFlags: {
        wrong: 'Falsch',
        harmful: 'Gefährlich/Schädlich/Illegal',
        offensive: 'Anstößig/Diskriminierend/Unfair',
        repetition: 'Wiederholung',
        unclear: 'Unklar',
        insufficient: 'Unzureichend',
        other: 'Sonstiges',
      },
      metric: 'Kennzahl',
      value: 'Wert',
      sessionStart: 'Sitzungsbeginn',
      sessionId: 'Sitzungs-ID',
      sessionTopic: 'Titel',
      messageCount: 'Nachrichten',
      sessionFallbackTitle: 'Sitzung {{id}}',
      showTotalSessionsLabel: `Insgesamt {{total}} Sitzungen`,
      statsLoading: 'Kennzahlen werden geladen …',
      metricHelp: {
        sessions:
          'Chat wurde geöffnet. Dies kann bereits automatisch beim Laden der Seite passieren. Zählt nur gespeicherte Unterhaltungen.',
        activeSessions:
          'Sitzungen, in denen mindestens eine Nachricht vom Nutzer gesendet wurde.',
        interactions: 'Anzahl der von Nutzern gesendeten Nachrichten.',
        meanInteractionsPerActiveSession:
          'Nutzernachrichten geteilt durch aktive Sitzungen.',
        ratedAnswers:
          'Antworten des Buddys, die mit „Gefällt mir“ oder „Gefällt mir nicht“ bewertet wurden.',
        likes:
          'Mit „Gefällt mir“ bewertete Antworten; in Klammern der Anteil an allen bewerteten Antworten.',
        dislikes:
          'Mit „Gefällt mir nicht“ bewertete Antworten; in Klammern der Anteil an allen bewerteten Antworten.',
        feedbackFlags:
          'Gründe, die Nutzer bei „Gefällt mir nicht“ ausgewählt haben. Sie schlüsseln diese Bewertungen weiter auf.',
      },
    },
    vad: {
      connectionError:
        'Verbindung zum Server fehlgeschlagen. Bitte versuchen Sie es später erneut.',
      unknownMicError:
        'Unbekannter Mikrofonfehler. Bitte prüfen Sie die Einstellungen Ihres Geräts und laden die Seite neu.',
    },
    speechCall: {
      answerLabel: 'Antwort:',
      questionLabel: 'Frage:',
      generatingAnswer: 'Antwort generieren...',
      detectingSpeech: 'Sprache erkennen...',
      listeningForSpeech: 'Warte auf Spracheingabe...',
      waitingForMicrophone: 'Warte auf Mikrofonfreigabe...',
      microphoneAccessDenied: 'Kein Zugriff auf das Mikrofon.',
      microphoneAccessDeniedDescription:
        'Kein Zugriff auf das Mikrofon. Bitte überprüfen Sie die Einstellungen in Ihrem Browser und laden die Seite neu.',
      sttRequestError: 'Spracherkennungsdienst ist nicht verfügbar.',
      sttRequestErrorDescription:
        'Der Dienst ist vorübergehend nicht verfügbar. Bitte prüfen Sie Ihre Netzwerkverbindung und versuchen Sie es zu einem späteren Zeitpunkt erneut.',
      requestAnswerError: 'Fehler beim Anfragen der Antwort.',
      requestAnswerErrorDescription:
        'Antwort konnte nicht erzeugt werden. Bitte ändern Sie ihre Anfrage und versuchen es später erneut.',
      preparingAudio:
        'Audio wird vorbereitet, warte auf die vollständige Antwort...',
      ttsUnavailable: 'Sprachausgabe ist nicht verfügbar.',
      ttsUnavailableDescription:
        'Die Antwort konnte nicht vorgelesen werden. Bitte prüfen Sie Ihre Netzwerkverbindung und versuchen Sie es zu einem späteren Zeitpunkt erneut.',
    },
    buddyEval: {
      advancedMode: 'Erweiterter Modus',
      importDataset: 'Dataset importieren',
      importFormatError: 'Nur .xls, .xlsx und .csv Dateien werden unterstützt.',
      importFormatHints: {
        title: 'Hinweise zum Datenformat',
        description:
          'Übernommen werden alle Spalten aus der Eingabe-Datei, welche folgende Spaltennamen als Überschrift in der ersten Zeile haben (Groß-/Kleinschreibung wird ignoriert):',
        columnNameTitle: 'Spaltenname',
        columnIdDesc: 'Die ID der Frage.',
        columnQuestionDesc: 'Die zu beantwortende Frage.',
        columnQuestionTitle: 'Frage',
        columnExpectedAnswerDesc: 'Die gewünschte Antwort (Gold-Standard).',
        columnExpectedAnswerTitle: 'Erwartete Antwort',
        columnActualAnswerDesc:
          'Antwort des Buddys (Optional: wenn die Antwort bereits erzeugt wurde und nicht mehr dynamisch vom Buddy erneut generiert werden soll).',
        columnActualAnswerTitle: 'Tatsächliche Antwort',
        missingData:
          'Keine zu importierenden Daten gefunden. Bitte überprüfen Sie die Daten. Beachten Sie dazu bitte auch die Hinweise zum Datenformat.',
      },
      importNotImplemented: 'Import-Funktion wird noch implementiert.',
      importDragHint: 'Datei hierher ziehen oder klicken zum Auswählen',
      importFormatHint: 'Unterstützte Formate: .xls, .xlsx, .csv',
      importSuccess: 'Dataset erfolgreich importiert.',
      unsavedChangesTitle: 'Ungespeicherte Änderungen',
      unsavedChangesContent:
        'Sie haben ungespeicherte Änderungen. Möchten Sie diese speichern oder verwerfen?',
      discardChanges: 'Verwerfen',
      distribution: 'Streuung',
      runSpread: 'Streuung zwischen Läufen',
      runSpreadTip:
        'Wie stark das Gesamtergebnis von Lauf zu Lauf schwankt: berechnet über den Mittelwert jedes Laufs. Kleine Werte heißen, der Buddy antwortet stabil.',
      answerSpread: 'Streuung über alle Antworten',
      answerSpreadTip:
        'Wie weit die Bewertungen einzelner Antworten auseinanderliegen, über alle Fragen und Läufe. 0 und 1 bedeuten nur, dass mindestens eine Antwort ganz falsch und eine ganz richtig war.',
      // Test Configs
      datasets: 'Datasets',
      testConfigs: 'Testkonfigurationen',
      testRuns: 'Testläufe',
      testRun: 'Testlauf',
      testcaseCount: 'Testfälle',
      searchConfigs: 'Konfigurationen suchen...',
      createConfig: 'Konfiguration erstellen',
      editConfig: 'Konfiguration bearbeiten',
      configDetails: 'Konfigurationsdetails',
      configNamePlaceholder: 'Name der Konfiguration',
      configDescriptionPlaceholder: 'Optionale Beschreibung',
      configName: 'Konfiguration',
      noTestcases: 'Keine Testfälle konfiguriert',
      modelClassName: 'Modell-Klasse',
      model: 'Modell',
      customEndpoint: 'Endpunkt',
      chatId: 'Chat-ID',
      taskClassName: 'Task-Klasse',
      prompt: 'Prompt',
      dataset: 'Dataset',
      // Test Runs
      runStatus: 'Status',
      progress: 'Fortschritt',
      searchRuns: 'Testläufe suchen...',
      startRun: 'Testlauf starten',
      cancelRun: 'Testlauf abbrechen',
      confirmCancelRun: 'Diesen Testlauf abbrechen?',
      confirmDeleteRun: 'Diesen Testlauf löschen?',
      viewResults: 'Ergebnisse anzeigen',
      runDetails: 'Testlauf-Details',
      startTime: 'Gestartet',
      endTime: 'Beendet',
      results: 'Ergebnisse',
      noResults: 'Keine Ergebnisse',
      overallSummary: 'Gesamtübersicht',
      successRate: 'Erfolgsrate',
      evaluations: 'Auswertungen',
      unanswered: 'Unbeantwortet',
      erroredMetrics: 'Metrik-Fehler',
      metricError: 'Fehler',
      customMetrics: 'Eigene Metriken',
      customMetricsTip:
        'Zusätzlich zu den Standardmetriken. Verwendet wird beim Start eines Laufs immer die aktuelle Version jeder Metrik.',
      noCustomMetrics: 'Noch keine eigenen Metriken angelegt',
      createMetric: 'Metrik anlegen',
      editMetric: 'Metrik bearbeiten',
      metricPrompt: 'Metrik-Prompt',
      metricPromptPlaceholder:
        'Was soll das Bewertungsmodell an der Antwort beurteilen? Frage, Antwort und Sollantwort werden automatisch angehängt.',
      metricType: 'Ergebnistyp',
      metricTypeNumeric: 'Numerisch',
      metricTypeEnum: 'Kategorien',
      metricMin: 'Minimum',
      metricMax: 'Maximum',
      metricMinBelowMax: 'Das Minimum muss kleiner als das Maximum sein',
      metricEnumValues: 'Erlaubte Werte',
      metricEnumLabel: 'Bezeichnung',
      metricEnumScore: 'Wertung (0–1)',
      metricEnumUnique: 'Bezeichnungen müssen eindeutig sein',
      metricEnumMin: 'Mindestens zwei Werte angeben',
      addEnumValue: 'Wert hinzufügen',
      metricThreshold: 'Schwellwert für „bestanden“',
      metricThresholdTipNumeric:
        'Auf der Skala der Metrik. Ohne Angabe gilt die Mitte der Skala.',
      metricThresholdTipEnum:
        'Mindestwertung (0–1), ab der eine Kategorie als bestanden gilt. Ohne Angabe gilt 0,5.',
      metricVersion: 'Version',
      deleteMetricConfirm:
        'Metrik löschen? Bereits gelaufene Auswertungen behalten ihre Ergebnisse, Konfigurationen mit dieser Metrik lassen sich danach aber nicht mehr starten.',
      metricNotFound: 'Diese Metrik existiert nicht mehr.',
      metricNameTaken: 'Es gibt bereits eine Metrik mit diesem Namen.',
      metricNameReserved:
        'Der Name darf nicht auf „[GEval]“ enden, diese Endung ist den Standardmetriken vorbehalten.',
      metricMissing:
        'Diese Konfiguration verwendet gelöschte Metriken: {{detail}}. Bitte die Konfiguration bearbeiten.',
      coarseScores:
        'Grobe GEval-Scores: das Bewertungsmodell unterstützt keine logprobs',
      coarseScoresHint:
        'Mit {{models}} kann GEval nur Vielfache von 0,1 liefern. Für feinere Scores das Bewertungsmodell auf gpt-4.1 umstellen.',
      evalInput: 'Eingabe',
      evalStatus: 'Status',
      actualOutput: 'Tatsächliche Ausgabe',
      expectedOutput: 'Erwartete Ausgabe',
      metricName: 'Metrik',
      metricReason: 'Begründung',
      answerDuration: 'Antwortabrufdauer',
      evalDuration: 'Evaluierungsdauer',
      repeat: 'Wiederholungen',
      repeatTip: 'Anzahl der Wiederholungen der Evaluierung',
      noDialogSelected: 'Kein Dialog ausgewählt',
      runStarted: 'Evaluierungslauf gestartet',
      runStartFailed: 'Fehler beim Starten des Laufs',
      runConfigLoadFailed:
        'Die Konfiguration dieses Laufs konnte nicht geladen werden',
      // Testcases & Tasks
      addTestcase: 'Testfall hinzufügen',
      addTask: 'Task hinzufügen',
      testcaseName: 'Testfall-Name',
      taskName: 'Task-Name',
      tasks: 'Tasks',
      modelPlaceholder: 'z.B. gpt-4o',
      runId: 'Lauf-ID',
      testsPassed: 'bestanden',
      atLeastOneTestcase: 'Mindestens ein Testfall ist erforderlich',
      atLeastOneTask: 'Mindestens ein Task ist erforderlich',
      datasetRequired: 'Bitte einen Datensatz auswählen',
      testcaseNamePlaceholder: 'Name des Testfalls',
      modelClassNamePlaceholder: 'z.B. OpenAI',
      customEndpointPlaceholder: 'Optionale Endpunkt-URL',
      chatIdPlaceholder: 'Optionale Chat-ID',
      taskNamePlaceholder: 'Name des Tasks',
      taskClassNamePlaceholder: 'z.B. AnswerPerformanceEval',
      promptPlaceholder: 'Evaluierungs-Prompt',
    },
  },
};
